/* eslint-disable prettier/prettier */
/**
 * Arabic resource file
 */

import { ArcTimelineGroups, ArcTimeLineValidationTypes, reviewNoteRoutes } from "../util/uiconstants";

export const labels = {
	// Panel Headers
	taskCategories: 'التنقل بين المهام',
	taskCategoryExecution: 'التنفيذ',
	taskList: 'قائمة المهام',
	taskDetails: 'تفاصيل المهمة',
	defaultDropdown: 'القائمة المنسدلة',
	status: 'الحالة',
	language: 'اللغة',
	channel: 'القناة',
	header: 'الرأس',
	headerName: 'اسم الرأس',
	sectionCustomLabelLabel: 'تسمية مخصصة',
	sectionNamePlaceHolder: 'أدخل عنوان القسم',
	showRelatedObjectLabel: 'عرض الكائنات المرتبطة',
	errorBanner: '{0} خطأ (أخطاء)',
	customize: 'تخصيص',
	customized: 'مخصص',
	custom: 'Custom',
	description: 'الوصف',
	entities: 'المنشآت',
	edit: 'Edit',
	delete: 'حذف',
	collapse: 'طي',
	expand: 'توسيع',
	saving: 'Saving...',
	//Modal
	addButton: 'إضافة زر',
	evidence: 'الدليل',
	temporary: 'مؤقت',
	priorPeriod: 'الفترة السابقة',
	externaldocuments: 'مستندات خارجية',
	name: 'الاسم',
	reason: 'Reason',
	browse: 'استعراض',
	uploadFile: 'تحميل الملفات',
	uploadDocument: 'Upload Document',
	duplicateDocumentHeader: 'One or more documents with the same name already exist in this engagement (either as Evidence or Temporary files).',
	duplicateDocumentInstruction: "Select ‘Overwrite’ to upload the document and replace the existing file or ‘Discard’ to cancel. If this existing file is in Evidence, then the document will be uploaded to Evidence. If the existing file is in Temporary files, then the document will be up",
	overwriteLabel: 'Overwrite',
	discardLabel: 'Discard',
	notes: 'ملاحظات',
	signOffs: 'التوقيعات',
	related: 'مرتبط',
	approveChanges: ' Approve changes',
	nodocumentsAdded: 'لم تتم إضافة أي مستندات',
	noDocumentsUpload: ' No documents are being uploaded',
	noSections: ' No sections available',
	noRequestMessage: 'لا توجد أي طلبات أو مهام خارجية في مهمة التدقيق هذه',
	noResultFound: 'لم يتم العثور على أي نتائج',
	results: 'results',
	searchPlaceholder: 'بحث',
	collaboration: 'مشاركة',
	object: 'الكائن',
	relateCollaboration: 'ربط المشاركة',
	reviewNote: 'ملاحظات المراجعة',
	documentReviewNotes: 'ملاحظات المستند',
	noEvidenceFilesAssociated: 'لا توجد ملفات أدلة مرتبطة بهذه المهمة ',
	taskReviewNoteWithParenthesess: 'ملاحظة (ملاحظات) المهمة',
	taskNotes: 'ملاحظات المهمة',
	documentsNotes: 'ملاحظات المستند',
	addNewDocumentNote: 'إضافة ملاحظة مستند',
	selectDocument: 'حدد مستند',
	taskReviewNotes: 'ملاحظات المهمة',
	showCleared: 'Show cleared',
	Replied: 'Replied:',
	showClosed: 'Show closed',
	allNotes: 'جميع الملاحظات',
	myNotes: 'الملاحظات الخاصة بي',
	noResultsFound: 'لم يتم العثور على أي نتائج',
	noTasksAvailable: 'لا توجد مهام متوفرة',
	noWCGWAvailableForTask: 'مخاطر الخطأ الجوهري غير متوفرة',
	noSubstantiveTasksAvailable: 'لا توجد أي مهام جوهرية مرتبطة',
	noNotesAssociatedWithDocument: 'لا توجد ملاحظات مرتبطة بهذا المستند',
	noNotesAssociatedWithTak: 'لا توجد ملاحظات مرتبطة بهذه المهمة',
	otherEngagementNotes: 'ملاحظات مهمة التدقيق الأخرى',
	to: 'إلى',
	deleteReviewNote: 'حذف',
	missingToUserError: 'مطلوب',
	missingReviewNoteTextError: 'نص ملاحظة المراجعة مطلوب',
	invalidReviewNoteTextError: 'تجاوز النص الذي تم إدخاله الحد المسموح به',
	dueDateRequiredTextError: 'Due date is required',
	saveNoteTextError: 'قم بالحفظ أو الإلغاء حتى تتمكن من المتابعة',
	//create dropdown texts
	create: 'إنشاء',
	addRequestText: 'الطلب',
	addExternalTaskText: 'External task',
	addFindingText: 'النتيجة',
	show: 'إظهار: ',
	riskTypeHeader: 'نوع المخاطر',
	wcgwHeader: 'الخطأ المحتمل',
	hasNotes: 'ملاحظات مفتوحة',
	hasNote: 'ملاحظة مفتوحة',
	noNotes: '( 0 ملاحظات مفتوحة)',
	addTemporaryFiles: 'إضافة ملفات مؤقتة',
	addPriorPeriodEvidence: 'إضافة دليل فترة سابقة',
	addExternalDocuments: 'إضافة مستندات خارجية',
	//Nav
	navHeaderTasks: 'المهام',
	navHeaderTaskCategory: 'فئات المهام',
	navFilterBy: 'خيارات عامل التصفية',
	navHeaderDocuments: 'المستندات',
	navHeaderCollaboration: 'مشاركة',
	navHeaderAutomation: 'أتمتة',
	navHeaderMore: 'المزيد',
	navDashboard: 'Dashboard',
	navReviewnotes: 'ملاحظات المراجعة',
	navHeaderManageteam: 'إدارة الفريق',
	navHeaderMangeteamNew: ' Manage team - New',
	mangeteam: ' Manage team',
	addmember: ' Add member',
	addnewmember: 'Add new member',
	addPriorPeriodMembers: 'Add prior members',
	addPriorPeriodUsers: 'Add prior period member',
	engagementrole: 'Engagement role',
	nopendingpriorperiodusers: 'No prior period members to invite',
	sendPriorPeriodUserInvitesWithCount: 'Send ({0}) invites',
	sendPriorPeriodUserInvitesWithoutCount: 'Send invites',
	priorPeriodMembersModalHeaderMessage: 'Select the prior period users that you would like to add to your current engagement',
	internalMember: ' Internal members',
	addinternalmember: 'Add internal member',
	noGroupFound: ' No access groups have been created in this engagement. Select \Add group\ to create a new external team member access group.',
	addGroup: ' Add group',
	addAccessGroup: 'Add access group',
	groups: ' Groups',
	addExternalMembers: ' All external members',
	members: ' Members',
	externalMember: ' External members',
	confidentiality: ' Confidentiality',
	member: ' Member',
	role: ' Role',
	actions: ' Actions',
	internalUserEdit: ' Edit',
	internalUserDeactivate: ' Deactivate',
	usersFilter: ' Filter',
	externalUserEdit: ' Edit',
	externalUserDeactivate: ' Deactivate',
	externalUserGroupLabel: ' groups',
	externalNoUserInGroup: ' No members have been added to this access group.',
	externalNoUserInAllGroup: ' No members have been added to this engagement.',
	independence: ' Independence',
	navManagegroup: 'إدارة المجموعة',
	navCRAsummary: 'ملخص التقييم الموحد للمخاطر',
	navAuditplan: 'خطة التدقيق',
	navWorkplan: 'خطة العمل',
	navSEM: 'مصفوفة التقييم الجوهري',
	navFindings: 'النتائج',
	navCanvasformupdates: 'تحديثات نموذج Canvas',
	navCopyhub: 'نسخ المركز',
	navExporthub: 'تصدير المركز',
	navReporting: 'إعداد التقارير',
	navAccountSummary: ' Account Summary',
	navScotSummary: ' Scot Summary',
	navItSummary: ' IT Summary',
	navGroupInstructionSummary: ' Group Instruction Summary',
	navHelixProjects: ' Helix Projects',
	navContentUpdates: 'Content Updates',
	navHelp: 'General help',
	validationNavHelp: 'Validation help',
	//Copyright
	copyRight: 'حقوق النشر © <السنة> جميع الحقوق محفوظة',

	//TopHeaderLayout.js
	topHeaderLayoutMilestoneText: 'المرحلة الرئيسية - مطابقة المعلومات المالية مع السجلات المحاسبية الأساسية. الحصول على دليل على أن المعلومات المالية المرحلية مطابقة للسجلات المحاسبية الأساسية. ',
	//TaskLayoutHeader
	taskLayoutHeaderSearchPlaceholder: 'بحث المهام',
	taskLayoutHeaderAssignments: 'التعيينات',
	taskLayoutHeaderAddTask: 'إضافة مهمة',
	wcgwSearchPlaceholder: 'بحث الخطأ المحتمل',
	//TaskListHeader
	taskListHeaderSortByDueDate: 'تاريخ الاستحقاق',
	taskListHeaderSortByTaskName: 'اسم المهمة',
	sortBy: 'فرز حسب:',
	ascending: 'تصاعدي',
	descending: 'تنازلي',
	taskListHeaderSortByKnowledge: 'خطة التدقيق',
	taskListHeaderDeleteWarning: 'هل أنت متأكد من أنك تريد حذف المهام المحددة.',
	taskListHeaderSortText: 'فرز',
	taskListHeaderSortOrderText: 'ترتيب الفرز',
	taskListHeaderTimePhaseText: 'الإطار الزمني',
	taskListHeaderBookMarkText: 'إشارة مرجعية',
	taskListHeaderFavoriteText: 'المفضلة',
	taskListHeaderEditText: 'تحرير عنوان المهمة',
	taskListHeaderMoveTaskText: 'تغيير مجموعة المهام',
	task: 'المهمة',
	toc: 'اختبار إجراءات الرقابة',
	tenNotes: '10 ملاحظات',
	source: 'المصدر',
	nature: 'الطبيعة',
	assertion: 'التأكيدات',
	testOfDetail: 'اختبار التفاصيل',
	testOfControl: 'اختبار إجراء الرقابة',
	substantiveAnalyticalProcedure: 'الإجراء التحليلي الجوهري',
	tod: 'TOD',
	sap: 'SAP',
	int: 'INT',
	ext: 'EXT',
	notSel: 'NOT SELECTED',
	internal: 'داخلي',
	external: 'خارجي',
	notSelected: 'غير محدد',
	documentCannotOpen: 'This document cannot be opened from Task Details. Navigate to the Documents List to open this document.',
	//TaskPanelLayout
	emptyTaskDetailsMessage: 'حدد مهمة لعرض التفاصيل',
	multiTaskSelectedMessage: 'To enable bulk controls, use the control key and select multiple tasks. \n If you would like to work on an individual task, select that task from the task list.',
	//Evidence
	evidenceDragAndDrop: 'سحب وإسقاط أو',
	//Timephases
	noResultTimePhase: 'لم يتم العثور على أي نتائج. يُرجى إعادة المحاولة',
	//handoff
	handoff: 'تسليم',
	handoffConfirmButtonText: 'تسليم',
	handoffModalTitle: 'تسليم المهمة',
	return: 'إعادة',
	returnDisabledMessage: "لا يمكن إرجاع هذه المهمة بسبب: (1) أنك المعدّ المعين لها، (2) أن حالة المهمة ليست 'قيد المراجعة' أو 'مكتملة'، أو (3) أنه لم يتم تعيين معدّ.",
	handOffTitleTip: 'تسليم للمراجعة',
	//Mark Complete
	markCompleteTitleTip: 'تعليم كمكتملة',
	markCompleteTitle: 'تعليم المهمة على أنها مكتملة',
	markCompleteText: 'سيتم وضع توقيعك على الدليل المرتبط بهذه المهمة كما هو موضح أدناه. سيتم تعليم المهمة على أنها مكتملة.',
	markCompleteTextLine1: 'سيتم وضع توقيعك على الدليل المرتبط بهذه المهمة كما هو موضح أدناه.',
	markCompleteTextLine2: 'سيتم تسليم هذه المهمة أو إعادتها إلى المستخدم المحدد.',
	markCompleteConfirm: 'تعليم كمكتملة',
	signOffAs: 'توقيع الكل بصفة:',
	additionalSignOff: 'مطلوب توقيعات إضافية',
	additionalTaskStatus: 'حالة تعيين المهمة',
	ep: 'شريك التدقيق',
	eqr: 'مراجع جودة التدقيق',
	closeMyAssignment: 'إغلاق التعيين الخاص بي',
	//TaskDetails
	taskDetailsAddRelate: 'إضافة/ ربط',
	taskDetailsDocument: 'مستند',
	taskDetailsAutomationRequest: 'طلب الأتمتة',
	taskDetailsExternalTask: 'المهمة الخارجية',
	taskDetailsFinding: 'النتيجة',
	taskDetailsRequest: 'الطلب',
	taskDetailsNotes: 'ملاحظات',
	taskDetailsRelatedTask: 'المهمة المرتبطة',
	epeqr: 'شريك التدقيق/مراجع جودة التدقيق',
	epeqrsignoffheader: 'التوقيع مطلوب',
	//Guidance
	guidance: 'توجيه',

	//RelatedItemHeader
	relatedItemsHeader: 'البنود المرتبطة',
	relateButtonText: 'ارتباط',
	createButtonText: 'إنشاء',
	relatedItemREQ: 'الطلب',
	relatedItemET: 'المهمة الخارجية',
	relatedItemATM: 'الأتمتة',
	relatedItemRelatedTask: 'المهمة المرتبطة ',//ex.PST

	//Links
	linksText: 'الارتباطات',
	//Forms
	formsText: 'النماذج',
	/*Accounts*/
	associatedTasks: 'المهام المرتبطة ببند الخطأ المحتمل',
	noAssertionsChecked: 'حدد تأكيد لعرض الأخطاء المحتملة المرتبطة',
	limitedRiskAccount: 'حساب محدود المخاطر',
	noAccountsCreated: 'لم يتم إنشاء حسابات',
	noDesignationSelected: 'لم يتم تحديد وظيفة',
	/*Risks*/
	risk: 'المخاطر',
	wcgw: 'الخطأ المحتمل',
	riskWcgw: 'المخاطر: الخطأ المحتمل',
	wcgwTasks: 'الخطأ المحتمل: المهمة',
	riskWcgwLabel: 'ربط المخاطر بالخطأ المحتمل',
	wcgwTasksLabel: 'ربط الخطأ المحتمل بالمهمة',
	noRiskTypes: 'لم يتم العثور على أنواع المخاطر',
	saveRisk: 'حفظ',
	noRisksFound: 'لم يتم العثور على المخاطر',
	haveBeenIdentified: 'have been identified',
	noAssertionFound: 'لم يتم ربط أي تأكيدات',
	noWCGWFound: 'There are no WCGWs related to this risk. Click on Edit Associations to relate one or more WCGWs.',
	noWCGWAvailable: 'لا يوجد مخاطر الخطأ الجوهري للتأكيد (التأكيدات) المحدد',
	relevantWcgwCountHint: 'The count displayed beside the account name should be read as the number of WCGWs related to assertions with a control risk assessment of not rely or assertions related to higher risk estimates, which have been associated to a substantive procedure, compared to the total number of these WCGWs.',
	noAccountsFound: 'No records found',
	selectAssertionToRelateWCGW: 'حدد تأكيد لربط المخاطر بالخطأ المحتمل',
	significantAccounts: 'حسابات جوهرية',
	riskName: 'المخاطر: ',
	accountName: 'الحساب: ',
	selectAll: 'تحديد الكل',
	noScotsFound: 'لا توجد فئات المعاملات الجوهرية المرتبطة',
	relatedwcgw: 'الأخطاء المحتملة المرتبطة',
	relatedRisks: 'مخاطر مرتبطة:',
	boltIconTitle: 'مخاطر مرتبطة',
	instructions: 'التعليمات:',
	expandRisk: '.1 قم بتوسيع بند مخاطر',
	selectAssertion: '.2 حدد تأكيد',
	identifyRelatedWCGW: '.3 حدد أن الخطأ المحتمل مرتبط بالمخاطر',
	clickAccount: '.1 انقر فوق حساب',
	selectWCGW: '.2 حدد خطأ محتمل',
	identifyRelatedTask: '.3 حدد المهام التي تستجيب للخطأ المحتمل',
	information: 'معلومات',
	requiredAssertions: 'التأكيدات المطلوبة',
	wcgwWithoutTasks: 'الخطأ المحتمل بدون المهام',
	no: 'لا',
	found: 'تم العثور علي',
	editAssociations: 'تحرير الارتباطات',
	riskWCGW: 'علاقة المخاطر: الخطأ المحتمل',
	wcgwTask: 'علاقة الخطأ المحتمل: المخاطر',
	requireTaskToBeRelated: 'يلزم مهمة لتكون مرتبطة',
	expandCollapse: 'انقر هنا للتوسيع / للطي',
	requiredAssertionsInfo: 'Show only assertions with a control risk assessment of not rely and assertions related to higher risk estimates',
	wCGWwithoutTasksInfo: 'Show only WCGWs related to an assertion with a control risk assessment of not rely and assertions related to higher risk estimates, that do not have any responsive substantive tasks associated',
	/*SEM*/
	select: 'تحديد',
	selectAnAccountFromTheDropDown: '.1 حدد الحساب من القائمة المنسدلة',
	applyAsertionsFilters: '.2 تطبيق تصفية التأكيدات',
	reviewTheTasksThatRespondToTheRisks: '.3 مراجعة المهمة (المهام) التي تستجيب للخطأ (الأخطاء)',
	riskOfMaterialMisstatement: 'مخاطر الخطأ الجوهري',
	expandScot: '.1 توسيع فئة المعاملات الجوهرية',
	selectWCGWToDisplayTheResponsiveTask: '.2 تحديد مخاطر الخطأ الجوهري لعرض المهام سريعة الاستجابة',
	tasksWithNoRelatedWCGW: 'مهام بدون مخاطر خطأ جوهري مرتبطة',
	selected: 'محدد',
	clearSelections: 'إلغاء تحديد الكل',
	romm: 'مخاطر الخطأ الجوهري',
	selectAccount: 'تحديد...',
	selectHeader: 'Select Header',
	riskOfMaterialMisstatementsWithoutRelatedTask: 'مخاطر الخطأ الجوهري بدون مهمة مرتبطة',
	selectOneOrMoreTasksToSeeTheRelatedROMM: 'حدد مهمة واحدة أو أكثر لرؤية مخاطر الخطأ الجوهري المرتبطة',
	invalidRelatedEntity: 'Related account cannot be found. Refresh the page and try again. Contact the Help Desk if the issue persists.',
	scrollUp: 'Scroll up',
	scrollDown: 'Scroll down',
	duplicate: 'Duplicate',
	showIndex: 'Show index',
	noContentAvailable: 'No content available',
	/*validations */
	semValidation: 'تحقق تسويق محركات البحث',
	riskWCGWValidation: 'التحقق من مخاطر الخطأ المحتمل',
	showValidation: 'التحقق من الصحة',
	wcgwWithNoRelatedTask: 'الأخطاء المحتملة بدون أي مهمة جوهرية مرتبطة',
	riskWithNoRelatedWCGW: 'المخاطر بدون خطأ محتمل مرتبط',
	noValidationIdentified: 'لم يتم تحديد التحقق من الصحة',
	/*CRA Badge*/
	ir: 'المخاطر الكامنة',
	cr: 'المخاطر المجمعة',
	cra: 'التقييم الموحد للمخاطر',
	selectToEdit: 'تحديد للتحرير',
	both: 'كلاهما',
	prefix: 'البادئة',
	suffix: 'الاحقة',
	optional: '(اختياري)',
	title: 'العنوان',
	charLimitExceeded: 'تم تجاوز حد الأحرف المسموح به',
	requiredField: 'الحقل مطلوب',
	Lastmodifiedby: 'آخر تعديل بواسطة',
	daysAgo: 'أيام مضت',
	currentlyBeingModifiedBy: 'يتم تعديله حالياً بواسطة',
	beingEditedInCoeditMode: 'Being edited in multi-user edit',
	coEditModeIsEnding: 'Multi-user editing is ending',
	coEditMode: 'Multi-user editing',
	checkInInProgressMessage: 'Check-in in progress. It may take up to 20 minutes for the document to be checked in. Please refresh for updates',
	checkOutInProgressMessage: 'Check-out in progress. It may take up to 20 minutes for the document to be checked out. Please refresh for updates',
	daasErrorMessage: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk',
	coEditModeIsStarting: 'Multi-user editing is starting',
	continue: 'استمرار',
	open: 'فتح',
	openReadOnly: 'فتح للقراءة فقط',
	takeControlFromTeam: 'إجراء الرقابة من عضو الفريق الحالي',
	itapplication: 'تطبيق تقنية المعلومات',
	aggregateITevaluation: 'التقييم المجمع لتقنية المعلومات:',
	control: 'إجراء الرقابة',
	itgcitsp: 'لجنة حوكمة تقنية المعلومات / الخطة الاستراتيجية لتقنية المعلومات',
	limitedRisk: 'حساب محدود المخاطر',
	so: 'هيكل الخدمات',
	itApp: 'تطبيق تقنية المعلومات',
	deleteTaskModalHeader: 'تأكيد حذف المهمة المحددة',
	deleteTasksModalHeader: 'تأكيد حذف المهام المحددة',
	deleteTaskModalMessage: 'هل أنت متأكد من أنك تريد حذف المهمة المحددة؟',
	deleteTaskModalMessage1: 'سيتم نقل الدليل المرتبط الذي لا يرتبط بأي مهام أخرى في مهمة التدقيق هذه إلى الملفات المؤقتة. سيتم حذف النتائج ومهام الاستجابة التي لا تتعلق بأي دليل آخر.',
	deleteTasksModalMessage: 'هل أنت متأكد من أنك تريد حذف المهام المحددة؟',
	deleteTaskModalKnowledgeHeader: 'تعذر حذف المهمة المحددة',
	deleteTasksModalKnowledgeHeader: 'تعذر حذف المهام المحددة',
	deleteTaskModalKnowledgeMessage: 'The selected task cannot be deleted.',
	deleteTasksModalKnowledgeMessage: 'The selected tasks cannot be deleted.',
	accountHeader: 'الحسابات',
	noAccountsIdentified: 'لم يتم تحديد أي حسابات.',
	noRisksIdentified: 'لم يتم تحديد أي مخاطر',
	noAssertionsIdentified: 'لم يتم تحديد أي تأكيدات',
	noWcgwsIdentified: 'لم يتم تحديد أي خطأ محتمل',
	// Tasks/TaskDetails/Evidence
	addEvidence: 'إضافة دليل',
	relateEvidence: 'ربط الدليل',
	relateTemporary: 'ربط ملفات مؤقتة',
	relatePriorPeriod: 'ربط دليل فترة سابقة',
	relateExtDoc: 'ربط مستندات خارجية',
	relateFile: 'ربط ملفات',
	createPaperProfile: 'إنشاء ملف ورقي',
	paperProfileInformationMessage: 'نقوم بإعداد كافة المستندات إلكترونياً، بما في ذلك توقيعات الإعداد والمراجعة. لا يُسمح بالتوثيق الورقي في أوراق عملنا إلا لتلك المستندات المقدمة لنا من الإدارة أو من طرف خارجي بصيغة ورقية والتي لا تتوفر منها نسخة إلكترونية (مثل صورة عن عقد موقع بين المنشأة وطرف خارجي).',
	paperProfileName: 'اسم الملف الورقي',
	paperProfileAdd: 'إضافة',
	paperProfileError: 'Please enter a valid paper profile name',
	thisEngagement: 'مهمة التدقيق هذه',
	otherEngagementsInWorkspace: 'مهام تدقيق أخرى في مساحة العمل هذه',
	relateDescription: 'ربط مستند من مهمة التدقيق هذه أو من مهمة تدقيق أخرى في مساحة العمل هذه.',
	onlyShowRelatedDocuments: 'إظهار المستندات المضافة فقط',
	relateDescriptionTemp: 'ربط مستند من مهمة التدقيق هذه.',
	added: 'تمت الإضافة',
	documentLocation: 'موقع المستند',
	addCanvasForm: 'إضافة نموذج Canvas',
	// Task/TaskDetail/Description
	noDescriptionAvailable: 'لا يتوفر وصف',
	knowledge: 'المعرفة',
	knowledgeDescription: 'وصف المعرفة',
	customizeDescription: 'وصف مخصص',
	custimizeTaskDescription: 'تخصيص وصف المهمة',
	editTaskDescription: 'تحرير وصف المهمة',
	saveLabel: 'حفظ',
	okLabel: 'موافق',
	cancelLabel: 'إلغاء',
	closeLabel: 'إغلاق',
	editText: 'تحرير',
	enterReply: 'أدخل الرد',
	reply: 'رد',
	requiredText: 'النص مطلوب',
	descriptionEmptyError: 'الوصف مطلوب',
	descriptionMaxLengthError: 'طول الوصف تجاوز الحد الأقصى للطول',
	// SeeMore component
	showMore: 'إظهار المزيد',
	showLess: 'إظهار أقل',
	showMoreEllipsis: 'إظهار المزيد...',
	showLessEllipsis: 'إظهار أقل...',

	// Request Description
	saveAndCloseButtonLabel: 'Save and close',
	saveButtonLabel:'Save',
	cancelButtonLabel: 'Close',


	// CharCount component.
	of: 'من',
	characters: 'الأحرف',
	fromUserLabel: 'من',
	toUserLabel: 'إلى',
	priorityLabel: 'الأولوية',
	dueDateLabel: 'تاريخ الاستحقاق',
	addNoteLabel: 'إضافة',
	characterCountLabel: ' من 4,000 حرف',
	taskNotePlacehodler: 'أدخل ملاحظة المهمة',
	documentNotePlacehodler: 'أدخل ملاحظة المستند',
	taskNoteStatusBy: 'بواسطة:',
	addNewReviewNoteButtonText: 'إضافة ملاحظة جديدة',
	fromKnowledge: 'من المعرفة',
	/*day labels*/
	mon: 'الاثنين',
	tues: 'الثلاثاء',
	wed: 'الأربعاء',
	thurs: 'الخميس',
	fri: 'الجمعة',
	sat: 'السبت',
	sun: 'الأحد',
	/*month labels*/
	jan: 'يناير',
	feb: 'فبراير',
	march: 'مارس',
	april: 'أبريل',
	may: 'مايو',
	june: 'يونيو',
	july: 'يوليو',
	august: 'أغسطس',
	sept: 'سبتمبر',
	oct: 'أكتوبر',
	nov: 'نوفمبر',
	dec: 'ديسمبر',
	/*Rename*/
	documentDropdown: 'القائمة المنسدلة للمستند',
	fileNameRequired: 'اسم الملف مطلوب',
	invalidCharacters: 'لا يمكن أن يتضمن اسم الملف: */:<>\\?|\"',
	existingFileName: 'اسم الملف غير مميز. قم بتحديث الصفحة أو إعادة تسمية الملف لإزالة هذه الرسالة.',
	unknowError: 'حدث خطأ غير متوقع. قم بتحديث الصفحة لإزالة هذه الرسالة.',
	maxLengthExceeded: 'لا يمكن أن يتجاوز اسم المستند 115 حرف.',
	/*Delete*/
	deleteFileTitle: 'حذف المستند',
	deleteFileCloseBtnTitle: 'إلغاء',
	deleteFileConfirmBtnTitle: 'حذف',
	deleteFileCloseTitle: 'إغلاق',
	deleteFileModalMessage: 'هل أنت متأكد من أنك تريد حذف المستندات المحددة؟',
	none: 'لا شيء',
	/*Unlink*/
	unlinkFileTitle: 'إلغاء ارتباط الدليل المشترك',
	unlinkSource: 'المصدر',
	unlinkTarget: 'الهدف',
	unlinkFileCloseBtnTitle: 'إلغاء',
	unlinkFileConfirmBtnTitle: 'تأكيد',
	unlinkFileCloseTitle: 'إغلاق',
	unlinkFileModalMessage: 'هل أنت متأكد من أنك ترغب في إلغاء ارتباط ملف الدليل المشترك هذا؟',
	/*Relate Tasks*/
	relateTasksTitle: 'Relate tasks',
	relateTaskSearchPlaceholder: 'Enter to search',
	/* Remove From Task */
	removeEvidenceModalTitle: 'إزالة من المهمة',
	remove: 'إزالة',
	removeFromTaskModalContent: 'هل أنت متأكد من أنك تريد إزالة المستند المحدد من هذه المهمة؟ هذا المستند غير مرتبط بأي مهمة أخرى في مهمة التدقيق هذه، وبالتالي سيتم نقله إلى الملفات المؤقتة.',
	/*AddDocumentToTasksModal*/
	modalCheckboxHeading: 'إضافة إلى الدليل بمهمة واحدة أو أكثر',
	modalRadioHeading: 'ربط المستند بمهمة واحدة أو أكثر',
	confirm: 'تأكيد',
	proceed: 'متابعة',
	modalCheckboxMessage: 'حدد المهام ذات الصلة لإضافة هذا المستند إليها.',
	documentName: 'اسم المستند',
	selectedDocument: 'Selected document',
	modalRadioMessage: 'تم إضافة هذا المستند من قبل إلى الدليل أو الملفات المؤقتة.',
	modalRadioMessage1: 'ستؤدي إضافة هذا المستند مرة أخرى إلى إنشاء نسخة مكررة. تحديد ما إذا كنت تريد ربط نسخة حالية من هذا المستند أو إنشاء نسخة جديدة من هذا المستند.',
	option: 'الخيار',
	option1Message: 'ربط مستند حالي بهذه المهمة',
	option2Message: 'إنشاء نسخة جديدة من هذا المستند',
	addToEvidenceSelectAll: 'تحديد الكل',
	currentTask: 'المهمة الحالية:',
	createNewCopy: 'إنشاء نسخة جديدة',
	fileNameMaxLenError: (maxFileLen) => 'يقتصر اسم الملف على ${maxFileLen} حرف.',
	/*SEM summary*/
	nextAccount: '>',
	prevAccount: '<',
	reviewedBy: 'تمت المراجعة بواسطة',
	displaytoc: 'عرض اختبار إجراءات الرقابة',
	viewBy: 'View by',
	substantiveEvaluation: 'مصفوفة التقييم الجوهري',
	reviewed: 'تمت المراجعة',
	estimate: 'مع تقدير',
	/*440GL*/
	FourFortyTitle: 'Evidence modified after report data ({0})',
	approveChangesColumnTitle: 'Approve changes',
	approveChangesButton: 'Approve changes',
	reasonColumnTitle: 'Reason',
	approvedBy: 'Approved by:',
	approvedByPeople: 'people',
	changeReasonModalTitle: 'Edit reason',
	changeReasonModalText: 'Select a new reason for this document',
	changeReasonModalComboPlaceholder: 'Select',
	/*Account Conclusion*/
	AccountConclusion: 'Account Conclusion',
	AccountDetails: 'Details',
	Conclusions: 'Conclusions',
	accountDetailsTab: 'details',
	conclusionsTab: 'conclusions',
	/*RelatedFindings*/
	deficiency: 'القصور',
	misstatement: 'الخطأ',
	deficiencies: 'أوجه القصور',
	misstatements: 'الأخطاء',
	pagingShowtext: 'إظهار',
	documentOpenModelLabel: 'يتم تعديل المستند حالياً',
	openedLabelText: 'مفتوح ',
	modelDocumentOpenedText: 'يتم تعديل هذا المستند حالياً بواسطة ',
	modelUserOpenedTheDocumentText: 'قام هذا المستخدم بفتح المستند ',
	modelOpenedDocumentConflictText: 'قد يؤدي فتح المستند إلى حدوث تعارضات، لذلك نوصي بفتحه للقراءة فقط. إذا كنت ترغب في أن تصبح محرر هذا المستند، إذن ',
	clickHereEnabledText: 'انقر هنا.',
	reviewNotesTemporeryFilesTitle: 'مراجعة الملاحظات للملفات المؤقتة',
	addNewReviewNoteTitle: 'ملاحظات المهمة',
	/*Assignments*/
	unassigned: 'غير معين',
	dueDateBlank: 'due',
	reviewerAssignment: 'تعيينات المراجع',
	manageTaskAssignments: 'إدارة تعيينات المهام',
	selectedTasks: 'المهام المحددة',
	taskGroupChangeHeaderTitle: 'تغيير مجموعة المهام',
	taskGroupChangeMessage: 'لا يمكن تغيير مجموعة لواحد أو أكثر من المهمة (المهام) المحددة.',
	taskGroupSectionNotFound: 'لم يتم العثور على أي نتائج',
	placeholderForSearch: 'بحث',
	taskFilter: 'تصفية',
	noResultsAvavilable: 'لم يتم العثور على أي نتائج',
	noTasksAvavilable: 'لا يتوفر مهام',
	clearAll: 'مسح الكل',
	engagementPhase: 'مرحلة مهمة التدقيق',
	noOptionAvailable: 'لا تتوفر أي خيارات',
	noTimePhase: 'بدون إطار زمني معين',
	preparer: 'مُعدّ',
	reviewer: 'مُراجع',
	roles: 'الأدوار',
	users: 'المستخدمون',
	rommAssociatedWNotRelyAssertion: 'ترتبط مخاطر الخطأ الجوهري بالتأكيد مع مخاطر عدم الاعتماد على إجراء الرقابة أو بالتأكيد ذو مخاطر كامنة أعلى حيث يحتوي الحساب على تقدير',
	hasRiskAssociated: 'المخاطر المرتبطة',
	canvas: 'Canvas',
	workingoffline: 'العمل بدون اتصال',
	syncinprogress: 'المزامنة قيد التنفيذ',
	prepareoffline: 'Preparing data for offline',
	connectionavilable: 'Connection available',
	// Manage Assignments
	step01: 'الخطوة 1',
	step02: 'الخطوة 2',
	step03: 'الخطوة 3',
	step04: 'الخطوة 4',
	step05: 'الخطوة 5',
	manageAssigmentsStep1: 'تحديد إجراء.',
	manageAssigmentsStep2: 'تحرير تعيين المهمة',
	manageAssigmentsStep3: 'إكمال التعيين',
	taskAssigmentStatusHeader: 'Task assignment status',
	taskAssignmentName: 'اسم تعيين المهمة',
	dueDateAssigment: 'الموعد النهائي',
	teamMemberAssigmentLabel: 'عضو الفريق',
	currentAssigmentLabel: 'حالي',
	handOffToAssigmentLabel: 'تم التسليم إلى:',
	daysAssigmentLabel: ' أيام قبل تاريخ الانتهاء',
	noTimePhaseAssigmentLabel: 'بدون إطار زمني معين',
	closedByAssigmentLabel: 'تم الإغلاق بواسطة ',
	onAssingmentLabel: 'بتاريخ',
	preparerAssigmentOpenTitleTip: 'قم بتسليم هذه المهمة لإغلاق تعيين المهمة الخاص بك',
	reviewerAssigmentOpenTitleTip: 'تعليم تعيين المهمة على أنه مغلق',
	reviewerAssigmentClosedTitleTip: 'تعليم تعيين المهمة على أنه مفتوح',
	AssigmentLabel: 'قم بتسليم هذه المهمة لإغلاق تعيين المهمة الخاص بك',
	noEvidenceReviewerAssigmentTitleTip: 'إضافة دليل لتعليم تعيين المهمة على أنه مغلق',
	back: 'عودة',
	savecontinue: 'حفظ واستمرار',
	finish: 'إنهاء',
	save: 'حفظ',
	emptyManageAssignmentStep: '...',
	selectAssignmentActionToContinue: 'حدد إجراء للمتابعة.',
	createNewTaskAssingment: 'إنشاء تعيين مهمة جديد',
	createTaskAssingment: 'إنشاء تعيين مهمة',
	editExistingTaskAssingment: 'تحرير تعيين المهمة الحالي',
	editTaskAssingment: 'تحرير تعيين المهمة',
	removeExistingTaskAssingment: 'إزالة تعيين المهمة الحالي',
	warningPopUpPreparerAssignmentTitle: 'الكتابة فوق تعيين المعدّ الحالي',
	warningPopUpPreparerAssignmentText: 'يوجد تعيين مسبق للمعدّ عن هذه المهمة. هل أنت متأكد من أنك تريد الكتابة فوق هذا التعيين؟',
	warningPopUpPreparerAssignmentConfirm: 'تأكيد',
	warningPopUpPreparerAssignmentCancel: 'إغلاق',
	selectTaskAssingment: 'تحديد تعيين المهمة',
	viewHistoryAndConflicts: 'View history',
	noHistoryAvailable: 'لا يتوفر أي سجل',
	teamMember: 'عضو الفريق',
	dateEdited: 'آخر تعديل',
	viewHistoryHeader: "This documents version history is displayed below.",
	viewHistorySubHeader: "Click on a team members name to open a previous version of this document in read-only mode. Any changes made to this previous version will not be saved to EY Canvas.",
	docConflictedMessage: "لا توجد تعارضات مرتبطة بهذا المستند. قم بالتنقل إلى علامة تبويب 'التعارضات' من قائمة المستندات للحل.",
	removeTaskAssingment: 'إزالة تعيين المهمة',
	addAssignmentInstructionalText: 'أدخل اسم تعيين مهمة جديد هنا (مثال. مراجع التفاصيل، المراجع العام)',
	addNewAssingmentName: 'إضافة اسم التعيين الجديد',
	addTaskAssignmentName: 'إضافة اسم تعيين المهمة',
	assignmentName: 'اسم التعيين',
	selectedTask: 'المهام المحددة',
	createTaskAssignmentHeading: 'أدخل تعيين المهمة هنا.',
	createTaskAssignmentHeading2: 'انقر فوق "حفظ" عند الانتهاء أو انقر فوق "حفظ ومتابعة" إذا كنت ترغب في إدارة تعيين مهمة آخر.',
	daysPriorToEndDate: 'أيام قبل تاريخ الانتهاء',
	timephase: 'الإطار الزمني',
	endDate: 'تاريخ الانتهاء',
	removeTaskAssingmentSingleTaskHeading: 'حدد تعيين المهمة الذي ترغب في إزالته.',
	removeTaskAssingmentSingleTaskHeading2: "انقر فوق 'حفظ' عند الانتهاء أو انقر فوق 'حفظ ومتابعة' إذا كنت ترغب في إدارة تعيين مهمة آخر.",
	removeTaskAssingmentMultipleTaskHeading: 'حدد اسم تعيين المهمة وعضو الفريق الذي ترغب في إزالته.',
	removeTaskAssingmentMultipleTaskHeading2: "في حالة وجود التعيين وعضو الفريق للمهام المحددة، سيتم حذفها. انقر فوق 'حفظ' عند الانتهاء أو انقر فوق 'حفظ ومتابعة' إذا كنت ترغب في إدارة تعيين مهمة آخر.",
	editTaskAssingnmentStep2Heading: 'حدد تعيين المهمة الذي ترغب في تحريره.',
	selectedAssignment: 'التعيين المحدد: ',
	editTaskAssingmentBulkHeading: 'حدد اسم تعيين المهمة وعضو الفريق الذي ترغب في تحريره.',
	editTaskAssingmentBulkHeading2: "في حالة وجود التعيين وعضو الفريق للمهام المحددة، سيتم حذفها. انقر فوق 'حفظ' عند الانتهاء أو انقر فوق 'حفظ ومتابعة' إذا كنت ترغب في إدارة تعيين مهمة آخر.",
	noResultInCategory: 'لم يتم العثور على أي نتائج ضمن فئة المهام الحالية',
	searchTaskList: 'بحث في قائمة المهام',
	clearHoverText: 'مسح',
	filtersWarningMessage: 'Filter limit exceeded. Only 25 filters can be applied at one time.',
	reviewNotesWarningMessage: 'حدث خطأ عند استرجاع البيانات. حاول مرة أخرى وفي حالة استمرار المشكلة، اتصل بمكتب الدعم.',
	editTaskAssingmentSept3Header: 'قم بتحرير تعيين المهمة المحدد.',
	editTaskAssingmentSept3Header2: "انقر فوق 'حفظ' عند الانتهاء أو انقر فوق 'حفظ ومتابعة' إذا كنت ترغب في إدارة تعيين مهمة آخر.",

	/* Sign Offs */
	preparerHoverText: 'توقيع كمُعد',
	reviewerHoverText: 'توقيع كمراجع',
	preparerTitle: 'توقيعات المعدّ',
	reviewerTitle: 'توقيعات المراجع',
	preparerLetter: 'المُعدّ',
	reviewerLetter: 'المُراجع',
	deleteHoverText: 'إزالة التوقيع',

	landingPage: 'الصفحة المتنقل إليها',
	dashboardPage: 'لوحة المعلومات',
	tasksPage: 'المهام',
	documentsPage: 'المستندات',
	collaborationPage: 'مشاركة',
	automationPage: 'أتمتة',
	newContentUpdate: 'Content update',
	clickForOptions: 'انقر للمزيد من الخيارات',
	offline: 'غير متصل',
	eyServiceGateway: 'EY Service Gateway',
	eyAutomation: 'EY Automation',
	eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

	est: 'له تقدير',
	bookmarkTaskModalHeader: 'تعذر تنزيل المهام المحددة',
	bookmarkTaskModalMessage: 'لا يمكن تنزيل المهام المحددة للعمل دون اتصال.',
	noGuidanceAvailable: 'لا يتوفر توجيه',
	next: 'التالي',
	previous: 'السابق',
	guidanceLink: 'الرابط',
	addToEvidenceLabel: 'إضافة إلى الدليل',
	otherEngagements: 'مهام التدقيق الأخرى',
	navigationView: 'عرض قائمة التنقل',
	listView: 'عرض القائمة',
	detailsView: 'عرض التفاصيل',
	closeguidance: 'إغلاق الدليل',
	reviewNotesModalClose: 'إغلاق',
	gamGuidanceLinkLabel: 'توجيهات دليل محاسبة المجموعات',
	notStarted: 'لم يتم البدء',
	inProgess: 'قيد التنفيذ',
	upcomingReview: 'للمراجعة القادمة',
	done: 'تم',
	teamSummaryEmptyTaskDetailsMesage: 'يقدم ملخص الفريق لقطة عن تعيينات كل عضو من الفريق:',
	taskSummaryPoint1: 'Select "To prepare" to view a list of preparer assignments for each team member.',
	taskSummaryPoint2: 'Select "To review" to view a list of reviewer assignments for each team member.',
	taskSummaryPoint3: 'يتم ترتيب التعيينات حسب حالة التعيين (لم يتم البدء، وقيد التنفيذ ومنجز).',
	noLinksfound: 'لم يتم العثور على روابط',
	noFormsfound: 'لم يتم العثور على نماذج',
	workofflinemsg: 'سيؤدي ذلك إلى تنزيل أحدث الإصدارات من المهام التي حددتها والسماح لك بمواصلة التحرير دون اتصال. يمكنك مزامنة التغييرات الي قمت بها لاحقاً من خلال إعادة الاتصال.',
	workonlinemsg: 'سيؤدي الاتصال مرة أخرى إلى مزامنة التغييرات تلقائياً. تأكد من توفر الاتصال بالإنترنت قبل إعادة الاتصال.',
	workoffline: 'العمل بدون اتصال',
	workonline: 'العمل باتصال',
	duplicateFileNames: 'Duplicate file names',
	training: 'Training',
	duplicateFileNameValidationMessage: 'The file that you are attempting to add to this engagement has the same name as an existing file in this engagement. Rename one of the files in order to proceed.',
	documentHelperConnectionIssue: "تم اكتشاف مشكلة في EY Canvas Document Helper.انقر فوق <a style='color:#467cbe' href='https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774' target='_blank' > here</a> للتعليمات حول كيفية حل هذه المشكلة.",
	incompleteCra: 'Incomplete CRA',
	noteItemCreated: 'Created:',
	NetworkErrorMessage: 'The application network is experiencing an error. Refresh the page and try again later. Contact the Help Desk if the error persists.',
	saveClose: 'Save & close',

	/* Add New Task */
	addnewTask: ' Add new task',
	taskType: ' Task type',
	taskTypeError: ' Please select task type',
	selectTaskTypeHeader: ' Select a task type to continue.',
	selectTaskType: ' Select task type',
	enterTaskDetails: ' Enter task details',
	assignTask: ' Assign task',
	taskGroup: ' Task group',
	finishLabel: ' Save & close',
	addTaskDetailsHeader: ' Enter task details in order to proceed.',
	addTaskAssignmentHeader: ' Optional: Enter the task assignment here.',
	addTaskDetailsSubHeader: ' Click \Continue\ if you wish to assign this task now. Click \Save & close\ if you wish to assign the task later.',
	addTaskAssignmentSubHeader: ' Click \Save & close\ when you are done or click \Save & continue\ if you wish to add another task assignment.',
	relateObjectHeaderAccount: 'Either select one or more assertions for an account or disclosure, or select a limited risk account in order to proceed.',
	relateObjectSubHeaderAccount: 'Tasks can only be related to one account, disclosure, or limited risk account.',
	relateObjectHeader: 'Relate one or more objects in order to proceed.',
	limitedRiskAccount: 'Limited risk account',
	onlyShowAddedObject: 'Only show added objects',
	relateObjectRequiredError: 'One or more objects must be selected in order to proceed.',
	invalidSelectionWarning: 'Tasks can only be related to one account, disclosure, or limited risk account. Remove the selected assertions or limited risk account in order to relate the task to different assertions or to a different limited risk account.',
	invalidSelctionCRA: 'Select a single object type',
	relateObjectOptionsHeaderAccountTask: 'Assertions and limited risk accounts',
	relateObjectOptionsHeaderITWalkthroughTask: 'IT/SO processes',
	relateObjectOptionsHeaderITControlTask: 'IT general controls',
	relateObjectOptionsHeaderITSubstantiveTask: 'IT substantive procedures',
	relateObjectOptionsHeaderSCOTControlTask: 'Controls',
	relateObjectOptionsHeaderSCOTWalkthroughTask: 'SCOTs',
	StrategyTypeControls: 'Controls',
	StrategyTypeSubstantive: 'Substantive',

	/* RNH Labels */
	emptyNoteDetailsMessage: 'Select a note to view details. To enable bulk controls, use the control or shift key and select multiple review notes. If you would like to work on an individual note, then select that note from the list.',
	emptyRepliesMessage: 'No replies yet',
	reviewNotes: 'review notes',
	showHideNotes: ' Show/Hide notes',
	fileType: ' File type',
	noteType: ' Type',
	statusId: ' Status',
	rnhDueDate: ' Due: ',
	rnhModifiedDate: ' Modified: ',
	textAreaPlaceholder: ' Enter note',
	requiredFieldErrorMessage: ' This is a required field.',
	meLabel: ' Me ',
	editIconHoverText: ' Edit',
	deleteIconHoverText: ' Delete',
	deleteIconModalTitle: 'Delete reply',
	deleteIconModalConfirmMessage: 'Are you sure that you want to delete your reply to this note?',
	deleteIconModalAcceptText: 'Delete',
	replyInputPlaceholder: 'Reply to this note',
	changeStatus: 'Change status',
	emptyReplyErrorMsg: 'Add text to continue',
	lengthReplyErrorMsg: 'The reply cannot exceed 4,000 characters.',

	/* Add new review note RNH */
	addNewNoteButtonTitle: ' Add note',
	addNewNoteModalTitle: ' Add new note',
	addNewNoteModalClose: ' Close',
	backButtonLabel: ' Back',
	cancelButtonLabel: ' Cancel',
	addNewNoteStep1Title: ' Select note type',
	addNewNoteStep2Title: ' Select document or task',
	addNewNoteStep3Title: ' Enter note details',
	editNoteModalTitle: ' Edit note',
	editReplyModelTitle: 'Edit reply',

	/* RNH Review note hub Step 1 */
	step1Title: ' Select a note type to continue.',
	step1NoTypeSelectedError: ' Select a note type in order to proceed.',

	/* RNH Review note hub Step 2 */
	step2DocumentTitle: ' Select the document that you would like to add a note to.',
	step2TaskTitle: ' Select the task that you would like to add a note to.',
	step2SearchTitle: ' Search',
	step2SearchClearTitleTip: ' Clear',
	step2ErrorMessageTop: ' Select an item in order to proceed.',
	step2ErrorMessageBottom: ' Complete the required fields identified above in order to proceed.',
	step2EmptySearch: ' No results found',

	/* RNH Review note hub Step 3 */
	step3InstructionalText: ' Enter the note details for the selected document or task.',
	step3InstructionalSubTitle: 'Click \'Save & close\' when you are done, or click \'Save & add another\' if you wish to add another note to the selected document or task.',
	step3SelectedDocument: 'Selected document:',
	step3SelectedTask: 'Selected task:',
	step3SaveAndContinue: 'Save & add another',
	step3SaveAndClose: 'Save & close',

	/* RNH List Layout Labels*/
	searchReviewNotes: ' Search notes',
	searchReviewNotesResultsNotFound: ' No results found within this note category',
	searchReviewNotesNotAvailable: ' No notes available',
	notesRepliesNotFound: ' No Replies found for the notes selected.',

	selectValueToContinue: ' Please select a value to continue',
	required: ' Required',
	invalidEngagementId: ' Engagement ID is invalid. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* RNH Filters */
	rnhClearAll: ' Clear all',
	rnhShowMore: ' more',
	rnhFilter: ' Filter',
	hideFiltersLabel: ' Hide',
	noDocumentChangeTypes: 'No results found',
	selectatasktype: ' Select a task type',
	importfromknowledge: ' Import from Knowledge',
	assigntaskoptional: ' Assign task (optional)',
	relateanobject: ' Relate an object',
	account: ' Account',
	standardtask: ' Standard task',
	substantivetask: ' Substantive task',
	scottask: ' SCOT task',
	itprocesstask: ' IT process task',
	userOrRole: ' User or role',
	userSummary: 'User summary',
	other: ' Other',
	userNotFound: ' User not found',

	/*Dashboard - Milestone tile*/
	milestonesLabel: ' Milestones',
	scopeAndStrategyTabLabel: ' Scope & Strategy',
	executionTabLabel: ' Execution',
	conclusionTabLabel: ' Conclusion',
	noTaskAssociatedToMilestoneMsg: ' There are no tasks associated to the milestones in this audit phase',
	overdueLabel: ' Overdue',
	quickLinkText: ' Quick links',
	inreviewLabel: 'In review',
	CompleteLabel: 'Complete',
	completeLabel: 'complete',
	startLabel: 'Start',
	endLabel: 'End',

	/* Document List */
	docListRelatedTasks: 'Related tasks',
	temporaryFilesTab: ' Temporary files',
	priorPeriodEvidenceTab: ' Prior period evidence',
	conflictsTab: ' Conflicts',
	recentlyDeletedTab: ' Recently deleted',
	shared: 'Shared',
	shareStatusOwned: 'Owned by this engagement.',
	shareStatusShared: 'Shared into this engagement.',
	documentList: 'Document list',

	/* Review Notes Count */
	noReviewNotesAssignedOrAuthored: 'No review notes have been assigned or authored',
	noUserSelected: 'Select a user to see details. You cannot assign notes to roles in EY Canvas.',
	reviewNotesText: 'review notes',
	assigned: ' Assigned',
	authored: ' Authored',
	overdue: ' overdue',
	cleared: ' Cleared',
	closed: 'مغلق',
	noTaskAssignedToUser: 'There are no tasks assigned to the selected user or role.',
	preparer: 'مُعدّ',
	reviewer: 'مُراجع',
	assignments: 'assignments',
	notStarted: 'لم يتم البدء',
	inProgress: 'In progress',
	done: 'تم',
	forUpcomingReview: 'Upcoming review',
	noTaskOrNotesAssigned: 'There are no tasks or notes for the selected user or role. Assign tasks or notes to the selected user or role to see data here.',

	/*Document Conflict*/
	documentConflict: 'Document Conflict',
	documentConflictModalConfirm: 'Retain this version',
	documentConflictModalClose: 'Cancel',
	documentConflictInstruction: 'To resolve the conflict, select the version of the version that should be retained.',
	documentConflictMessage: 'Click on a team member\'s name to open a previous version of this document in read-only mode. Any changes made to this previous version will not be saved to EY Canvas.',
	lastmodifiedDate: 'Last Modified Date',
	modifiedBy: 'Modified By',
	documentConflictErrorMessage: 'Select a version in order to proceed.',
	currentVersion: 'Current version',
	documentConflictError: 'Document Conflict Error Message',
	documentConflictHeader: 'This document has a conflict.',

	/* Dashboard  - Collaboration Tile*/
	collaborationTileHeader: ' Collaboration',
	receivedStatusLabel: ' Received',
	acceptedStatusLabel: ' Accepted',
	outstandingStatusLabel: ' Outstanding',
	collaborationNonUsageMessage1: 'Use Collaboration to send requests and external tasks to external team members directly in EY Canvas. To activate Collaboration, first enroll your client in EY Canvas Client Portal. Next, set up access groups. Then, create requests and/or assign external tasks. Click',
	collaborationNonUsageMessage2: '  for enablement on how to get started.',
	collaborationNonUsageMessageHyperlinkText: ' here',
	collaborationNonSentMessage1: ' Navigate to ',
	collaborationNonSentMessage2: '  and send drafts to get started.',
	collaborationNonSentMessageHyperlinkText: ' Collaboration',
	noBodies: 'No bodies',
	editResponse: 'Edit response',
	unsentDrafts: 'unsent drafts',
	noUnsentDrafts: 'No unsent drafts',
	totalSent: 'total sent',

	/* Dashboard Engagement Metrics */
	engagementMetricsTileHeader: 'Engagement Metrics',
	overdueColumnHeader: 'Overdue',
	comingDueColumnHeader: 'Coming due',
	whatsNewColumnHeader: 'Whats new',
	placeholderMessageNoContentInSpecifiedTimeframe: 'No data available for the selected time-frame',

	// Dashboard - todo list
	todoListOpen: 'لم يبدأ أو قادم (فتح)',
	todoListInProgress: 'المعينة حاليًا (قيد التقدم)',
	todoListClosed: 'اكتمل بواسطتي (مغلق)',

	/* RNH Bulk Controls */
	rnhBulkAssignPriorityTitle: 'Change priority',
	rnhBulkAssignPriorityTooltip: 'Priority',
	rnhBulkDueDateTooltip: 'Due date',
	rnhBulkAssignPriorityModalHeader: 'Unable to edit the selected notes',
	rnhBulkAssignPriorityModalContent: 'You can only change the priority of notes with Open status. Reopen notes with Cleared or Closed status in order to change the priority.',
	rnhBulkAssignDueDateModalContent: 'You can only change the due date of notes with Open status. Reopen notes with Cleared or Closed status in order to change the due date.',
	rnhBulkAssignUserTooltip: 'Reassign',
	rnhBulkAssignUserSearch: 'Search',
	rnhBulkAssignUserModalTitle: 'Unable to edit the selected notes',
	rnhBulkAssignUserModalText: 'You can only re-assign notes with Open status. Reopen notes with Cleared or Closed status in order to re-assign.',
	rnhBulkAssignStatusTooltip: 'Status',
	rnhBulkAssignUserNoFound: 'No results found',
	rnhBulkDueDatePlaceholder: "Pick a date",

	fourFortyFilters: 'filters',
	fourFortySearch: 'Search',

	/* Add External Member Start*/
	addExternalModalTitle: "Add external member",
	accessGroupSelection: "Access group selection",
	noRecordinGroups: "No results found",
	permission: "Permissions",
	permissionProjectManagement: "Project Management",
	permissionProjectManagementDesc: "Ability to view the status of client requests and external tasks in EY Canvas Client Portal. This external member will not be able to access details of client requests and external tasks.",
	permissionInfoTooltip: "list of all permissions",
	groupInfoTooltip: "list of groups",
	groupRequired: "Please select group(s)",
	firstnameRequired: "First name required",
	lastnameRequired: "Last name required",
	initialsRequired: "Initials required",
	engagementRole: 'Engagement role',
	roleRequired: 'Engagement role required',
	groupLabel: "Access groups",
	firstnameLabel: "First name",
	lastnameLabel: "Last name",
	initialsLabel: "Initials",
	userinfo: "User Info",
	userinfoDescription: "Enter the first name, last name or email address of the team member you want to invite and press enter.",
	inviteAndClose: "Invite & close",
	inviteAndAddOther: "Invite & add another",
	externalUserCreatedSuccessMessage: "You have successfully added external user",

	/* Add External Member End*/


	/*access group*/
	groupName: "Group name",
	groupNameHelp: "A name is required in order to create an access group.",
	groupNameReq: "Group name required",
	grpDomainManage: 'Manage domains',
	grpDomainHelp: 'Add atleast one domain to create access group.',
	btnAddNewDomain: 'Add new domain',
	btnAddExistingDomain: 'Add existing domain',
	domainValidation01: 'Atleast one valid domain is required',
	domainValidation02: "Choose a domain",
	domainValidation03: "Duplicate entry",
	domainValidation04: "Invalid domain name",
	domainValidation05: "Domain name required",
	domainName: 'Domain name',
	emailDomain: 'Email domain',

	/* uncommon values for internal mem */
	listOfAllPerm: "List of all permissions",
	internalPermiInviteExt: "Invite internal members",
	internalPermiInviteInt: "Invite external members",
	internalPermiAssignPer: "Assign permissions",
	internalPermiDeleteEng: "Delete engagement",
	internalPermiArchEng: "Archive engagement",
	internalPermiUpdateContet: "Update content",

	internalPermiInviteExtToolTp: "Ability to invite internal team members to the engagement",
	internalPermiInviteIntToolTp: "Ability to invite external team members to the engagement",
	internalPermiAssignPerToolTp: "Ability to assign these permissions to internal and external team members in the engagement",
	internalPermiDeleteEngToolTp: "Ability to delete the engagement",
	internalPermiArchEngToolTp: "Ability to archive the engagement",
	internalPermiUpdateContetToolTp: 'Ability to edit the profile and accept a content update',
	internalMemberInviteSuccessMessage: 'You have successfully sent an invite to {0} {1}.',
	/*user search component*/
	seachInputRequired: 'Search input required',
	nameOrEmail: "Name or email",
	noRecord: "No results found",
	userSearchPlaceholder: "Enter name or email and press enter to see results.",
	clearAllValues: 'Clear all values',
	inValidEmail: 'Please enter valid email',

	maxLengthForEditResponse: "Maximum characters, including rich text formatting tags, is 30,000. Remove unnecessary formatting and try again.",
	clickEditResponseToContinue: 'Click edit response to continue',
	bodyDescriptionFromKnowledge: 'Body description from knowledge',
	scopeAndStrategy: 'Scope and Strategy',
	execution: 'Execution',
	pastingImagesNotAllowed: 'Pasting of images is not allowed. If images are required upload them as evidence and refer to them.',
	saveResponse: 'There are unsaved changes, do you want to continue',
	conclusion: 'Conclusion',
	referenceDocsPlaceHolder: 'Quickly open frequently-accessed files by adding them here',
	teamDocuments: 'Team documents',
	myDocuments: 'My pinned',
	referenceDocuments: 'Team pinned',

	/* Arc Timeline */
	arcTitle: "Archive checklist",
	arcCompleted: "completed",
	arcSubmit: "Submit archive",
	arcDescription: "Must complete all checklist steps to archive engagement",

	/*Helix Projects*/
	linkedProjects: 'Linked projects',
	linkSelected: 'Link selected',
	noLinkedProjectsAvailable: 'There are no linked project',
	helixProjectTitle: 'EY Helix Projects',
	findProjects: 'Find Projects',
	selectProjectsToLink: 'Select one or more EY Helix projects below to create a link with your Canvas engagement. You can manually search by Client code to ﬁnd other EY Helix projects.',
	newSearch: 'New search',
	noResultsFound: 'No results found.',
	enterClientCode: 'Enter a client code to search again.',
	mirrorCodesNotAccepted: 'Note that mirror codes are not accepted.',
	helixProjectSearch: 'Search',
	helixProjectsSearchPlaceholderText: 'Enter client code to search',

	/*Helix Projects Table*/
	tableShowing: 'Showing results for: ',
	tableClientCode: '- Client code:',
	tableEngagementCode: 'Engagement code',
	tableEngagementCodeName: 'Engagement code name',
	tableProjectID: 'Project ID',
	tableProjectName: 'Project name',
	tablePeriodEndDate: 'Period end date',
	tableAnalysisDate: 'Analysis date',
	tableAssignedPartner: 'Assigned partner',

	/*Content Update */
	quote: '"',
	performContentUpdate: 'Perform content update',
	selectAll: "تحديد الكل",
	contentupdate: 'Content updates',
	btnContentUpdate: 'Update',
	updateSuccessMessage: 'Content update submitted',
	msgContentUpdate: 'Select one or more categories below to update the content:',
	msgWarningTitle: 'Warning',
	btnProceedContentUpdate: 'Proceed',
	btnCancelContentUpdate: 'Cancel',
	confirmationMessageP1: 'You are about to complete a content update for the selected content categories. Select',
	confirmationMessageP2: 'to continue or select',
	confirmationMessageP3: 'if you do not wish to complete the content update at this time.',
	warningMessage: 'One or more content types must be selected for update',
	groupReportingFormsSent: 'Group reporting forms sent',
	groupReportingFromStatus: 'Group reporting form status',
	primaryTeamReviewStatus: 'Primary team review status',
	primaryTeam: 'Primary team',
	group: 'Group',
	primaryTeamGroupTaskPlaceholder: "Create components and send group instructions to monitor progress",
	/*Preapre for Arc*/
	YearEndDate: "Year end date:",
	PeriodEndDate: "End date of period covered:",
	ReportDate: "Report Date:",
	ArcDeadlineDate: "Archive deadline date:",
	ClientCode: "Client Code:",
	PrimaryEngCode: "Primary engagement code:",
	SecondaryEngCode: "Secondary engagement code:",
	ReportType: "Report type:",
	noObjectsAvailable: 'No objects available',
	CurrentlyUnavailable: 'Currently unavailable',
	primaryTeamGroupTaskPlaceholder: "Create components and send group instructions to monitor progress",

	//#region Filter

	filter: 'Filter',

	//#region Document list filters
	filterSignedOffByUserLabel: 'Signed off by',
	filterSignOffMissingLabel: 'Missing sign offs',
	filterNotSignedOffByUserLabel: 'Not signed off by',
	filterLastModifyUserLabel: 'Last modified by',
	filterModifiedAfterLabel: 'Modified after',
	filterModifyAfterReviwerSignoffLabel: 'Modified since reviewer sign-off',
	filterReviewNoteStatusLabel: 'Review note status',
	filterReviewNoteAssignedToLabel: 'Review notes assigned to',
	filterReviewNoteAuthoredByLabel: 'Review notes authored by',
	filterReviewNoteOtherEngagementLabel: 'Review notes from other engagements',
	filterFileExtensionLabel: 'File extension',
	filterDuplicateFileNameLabel: 'Duplicate file name',
	filterDocumentContentLabel: 'Document content',
	filterSharedEvidenceLabel: 'Shared evidence',
	filterGroupAuditComponentLabel: 'Region/Component team',
	filterFindingsLabel: 'Findings',
	 //#endregion

	//Session Timeout
	sessionTimerMsg:
		'Due to inactivity, your current work session is about to expire. For your security, EY Canvas sessions end automatically after 30 minutes of inactivity. Your current session will expire in {0} minutes. If you wish to remain logged in, please click Continue.',
	logout:'Logout',
	sessionPopupTitle: 'Automatic logout for your protection',

	//#endregion

	pendingResponseLabel: 'Pending response',
	receivedLabel: 'Received',

	softwareUpdate: 'Software updates',
	updateNow: "Update now",
	updateMsg: "Software updates are available for EY Canvas. Do you want to download and install them? IF ANY DOCUMENTS ARE OPEN OR YOU HAVE UNSAVED WORK, SELECT UPDATE LATER. If all documents are closed and work in EY Canvas is saved, select Update Now.",

	// Adobe Analytics
	aaCookieConsentTitle: 'Welcome to',
	aaCookieContentPrompt: 'Do you want to allow cookies?',
	aaCookieConsentExplanation:
		'<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentExplanationWithDoNotTrack:
		'<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>We have detected that you have enabled the Do Not Track setting in your browser; as a result, Advertising/Targeting cookies are automatically disabled.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentDeclineOptionalAction: 'I decline optional cookies',
	aaCookieConsentAcceptAllAction: 'I accept all cookies',
	aaCookieConsentCustomizeAction: 'Customize cookies',
	aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

	// Cookie Settings
	cookieSettings: {
		title: 'Cookie Settings',
		explanation:
			'Please provide your consent for cookie usage on ey.com and the My EY platform. Select one or more of the cookie types listed below, and then save your selection(s). Refer to the listing below for details on the types of cookies and their purpose.',
		emptyCookieListNotice:
			'Cookies from this category are not used in this app',
		nameTableHeader: 'Name of cookie',
		providerTableHeader: 'Cookie provider',
		purposeTableHeader: 'Purpose of cookie',
		typeTableHeader: 'Type of cookie',
		durationTableHeader: 'Duration of cookie',
		formSubmit: 'Save my selection',
		requiredCookieListTitle: 'Required Cookies',
		functionalCookieListTitle: 'Functional Cookies',
		functionalCookieAcceptance: 'I accept the functional cookies below',
		functionalCookieExplanation:
			'Functionality cookies, which allow us to enhance your experience (for example by remembering any settings you may have selected).',
		performanceCookieListTitle: 'Performance Cookies',
		performanceCookieAcceptance: 'I accept the performance cookies below',
		performanceCookieExplanation:
			'Performance cookies, which help us measure the website’s performance and improve your experience. In using performance cookies we do not store any personal data, and only use the information collected through these cookies in aggregated and anonymised form.',
		advertisingCookieListTitle: 'Targeting Cookies',
		advertisingCookieAcceptance:
			'I accept the advertising/targeting cookies below',
		advertisingCookieExplanation:
			'Advertising/targeting cookies, which we use to track user activity and sessions so that we can deliver a more personalized service, and (in the case of advertising cookies) which are set by the third parties with whom we execute advertising campaigns and allow us to provide advertisements relevant to you.',
		doNotTrackNotice:
			'We have detected that you have enabled the Do Not Track setting in your browser; as a result, advertising/targeting cookies are automatically disabled.'
	},
};



/*Errors*/
export const Errors = {
	/*Accounts*/
	1001: 'فشل استدعاء إنشاء حساب.',
	1002: 'اسم الحساب غير موجود.',
	1003: 'AR MS Account is not valid.',
	1004: 'فشل استدعاء الحساب.',
	1005: 'معرف مهمة التدقيق غير صالح.',
	1006: 'نوع الحساب غير صالح.',
	1007: 'نوع البيان غير صالح.',
	1008: 'معرف الحساب غير صالح.',
	1009: 'فشل استدعاء الحساب حسب المعرف.',
	1010: 'فشل استدعاء الحساب حسب معرف مهمة التدقيق.',
	1011: 'فشل استدعاء ملخص تسويق محركات البحث لمعرف الحساب بسبب طلب غير صالح.',
	1012: 'نوع الملخص غير صالح.',

	/*Assertions*/
	2001: 'طلب الإنشاء غير صالح.',
	2002: 'اسم التأكيد غير موجود.',
	2003: 'التأكيد غير موجود.',
	2004: 'فشل استدعاء التأكيد.',
	2005: 'معرف مهمة التدقيق غير صالح.',
	2006: 'فشل استدعاء التأكيد حسب المعرف.',
	2007: 'فشل استدعاء تأكيد الأخطاء المحتملة.',

	/*Risks*/
	4001: 'فشل استدعاء مخاطر الإنشاء.',
	4002: 'اسم المخاطر غير موجود.',
	4003: 'المخاطر غير موجودة.',
	4004: 'فشل استدعاء المخاطر.',
	4005: 'معرف مهمة التدقيق غير صالح.',
	4006: 'فشل استدعاء المخاطر حسب المعرف.',
	4007: 'طلب الاستعلام غير صالح.',
	4008: 'معرف المخاطر غير صالح.',
	4009: 'طلب التحديث غير صالح.',
	4010: 'تم تعيين الخطأ المحتمل المحدد بالفعل لهذه المخاطر',
	4011: 'قائمة الخطأ المحتمل لا يمكن أن تكون لا شيء',
	4012: 'فشل استدعاء أنواع المخاطر.',
	4013: 'طلب الإنشاء غير صالح.',
	4014: 'التأكيد المرتبط غير صالح. قم بتحديث الصفحة وحاول مرة أخرى. في حالة استمرار الخطأ، اتصل بمكتب الدعم.',
	4015: 'الخطأ المحتمل غير صالح. قم بتحديث الصفحة وحاول مرة أخرى. في حالة استمرار الخطأ، اتصل بمكتب الدعم.',
	4016: 'AR MS Risk is not valid.',
	4017: 'التأكيد غير صالح للمخاطر. قم بتحديث الصفحة وحاول مرة أخرى. في حالة استمرار الخطأ، اتصل بمكتب الدعم.',
	4018: 'معرف نوع المخاطر الذي تم تمريره غير صالح.',
	401000: 'Network change is detected and please reload the page to continue',

	/*TASK*/
	5001: 'فشل استدعاء الكل.',
	5002: 'This task is no longer available in this engagement.',
	5003: 'فشل استدعاء المستندات للمهمة. محددات الطلب غير صالحة.',
	5004: 'فشل استدعاء المهمة المرتبطة بالمستند. محددات الطلب غير صالحة.',
	5005: 'فشل استدعاء المهمة حسب المعرف.',
	5006: 'فشل استدعاء فئات المهام.',
	5007: 'فشل استدعاء الفئات الفرعية للمهام.',
	5008: 'فشل استدعاء وصف المهمة.',
	5009: 'فشل استدعاء طلبات العميل للمهمة.',
	5010: 'فشل حفظ استدعاء طلبات العميل للمهمة.',
	5011: 'المهمة التي تحاول ربط العناصر بها قد تم حذفها أو رفضها.',
	5012: 'البند الذي تحاول ربط العناصر به قد تم حذفه أو رفضه.',
	5013: 'المهمة التي تحاول ربط العناصر بها قد تم حذفها أو رفضها.',
	5014: 'المستند الذي تحاول ربط العناصر به قد تم حذفه أو رفضه.',
	5015: 'فشل استدعاء الأدلة للمهمة.',
	5016: 'فشل استدعاء مهمة الخطأ المحتمل.',
	5017: 'يجب أن يكون معرف مهمة التدقيق أكبر من الصفر.',
	5018: ' Task ID is not found.',
	5019: 'وصف المهمة فارغ',
	5020: 'تم حذف أو رفض المهمة المحددة. لذلك، لا يمكن إكمال هذا الإجراء في الوقت الحالي.',
	5021: 'معرف مصدر مهمة التدقيق غير موجود.',
	5022: 'فشل حفظ التعليق التوضيحي',
	5023: 'لم يتم العثور على مستخدم مهمة التدقيق.',
	5024: 'فشل استدعاء حذف المهمة.',
	5025: 'فشل استدعاء حذف المهام.',
	5026: 'قائمة المهام فارغة',
	5027: 'لم يتم العثور على المراجعة.',
	5028: 'اسم الملف مطلوب.',
	5029: 'امتداد الملف مطلوب.',
	5030: 'لا يمكن أن يتضمن اسم الملف: */:<>\\?|\"',
	5031: 'خطأ في تحديث اسم المستند.',
	5032: 'معرف المستند غير صالح',
	5033: 'لم يتم العثور على نوع العملية.',
	5034: 'فشل تغيير حالة المهمة',
	5035: 'The action you are trying to perform cannot be completed at this time. Please try again later. Contact the Help Desk if this error persists.',
	5036: 'النص لا يمكن أن يكون لا شيء أو فارغاً في الاتصال.',
	5037: 'الطلب لا يمكن أن يكون لا شيء في الاتصال.',
	5038: 'أدخل اسم ملف مميز للمتابعة.',
	5039: 'اسم الملف مطلوب.',
	5040: 'اسم الملف يقتصر على 100 حرف.',
	5041: 'لا يمكن أن يتضمن اسم الملف: */:<>\\?|\"',
	5042: 'المهمة المحدد مرفوضة.',
	5043: 'المهمة هي مهمة خطوة بناء.',
	5044: 'المهمة هي مهمة مرحلة إنجاز رئيسية.',
	5045: 'المهمة هي ليست نوع إجراءات جوهرية رئيسية أو إجراءات جوهرية أخرى.',
	5046: 'تم تجاوز حد الأحرف المسموح به.',
	5047: 'تم تجاوز حد الأحرف المسموح به.',
	5048: 'الحقل مطلوب',
	5049: 'لا يمكن لإزالة المستند المحدد من هذه المهمة. قم بتحديث الصفحة وحاول مرة أخرى. في حالة استمرار المشكلة، اتصل بمكتب الدعم.',
	5050: 'يجب ألا يكون معرف مجموعة المهام صفر أو غير صالح.',
	5051: 'يجب ألا يكون معرف قسم المهام صفر أو غير صالح.',
	5052: 'حدث خطأ أثناء محاولة إضافة هذا المستند إلى المهمة الحالية. فشل الاستدعاء.',
	5053: 'حدث خطأ أثناء محاولة تحديث هذا المستند في المهمة الحالية. فشل الاستدعاء.',
	5054: 'حدث خطأ أثناء محاولة إضافة نسخة من هذا المستند في المهمة الحالية. فشل الاستدعاء.',
	5055: 'حدث خطأ أثناء محاولة إعادة تسمية المستند. فشل الاستدعاء.',
	5056: 'لا يمكن تحرير عنوان المهمة للمعرفة أو مجموعة المهام',
	5057: 'يجب أن يكون نوع المهمة نوع المهام القياسية الأخرى',
	5058: 'لا يمكن إزالة هذا المستند من المهمة لأنه يرتبط بالنظام.',
	5059: 'قيمة الإطار الزمني غير صالحة.',
	5060: 'خطأ في الإضافة إلى الدليل. فشل الاستدعاء.',
	5061: 'قام مستخدم آخر بتحديث المعلومات المعروضة. قم بتحديث الصفحة وحاول مرة أخرى. في حالة استمرار الخطأ، اتصل بمكتب الدعم.',
	5062: 'The selected document cannot be related from this task. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5063: 'عملية التصحيح غير صالحة.',
	5064: 'تم حذف أو رفض المهمة المحددة. لذلك، لا يمكن إكمال هذا الإجراء في الوقت الحالي.',
	5065: 'تعذر تحديث نوع مصدر المهمة. الطلب غير صالح.',
	5066: 'Get guidance error. Call failed.',
	5067: 'تعذر تحديث نوع طبيعة المهمة. الطلب غير صالح.',
	5068: 'تعذر تحديث نوع طبيعة المهمة. الطلب غير صالح.',
	5069: 'فشل استدعاء حذف تعيين المهمة.',
	5070: 'تم حذف مهمة واحدة أو أكثر من المهام المحددة. يُرجى إعادة المحاولة أو اتصل بمكتب الدعم في حالة استمرار المشكلة.',
	5071: 'تعذر تحديث المهمة. الطلب غير صالح.',
	5072: 'لم يتم العثور على المُعدّ. الطلب غير صالح.',
	5073: 'لم يتم العثور على التعيينات.',
	5074: 'فشل حفظ تعيين المهمة',
	5075: 'يمكن تعيين نفس عضو الفريق فقط إلى تعيين مهمة واحد بخلاف المعدّ. يُرجى إعادة المحاولة أو اتصل بمكتب الدعم في حالة استمرار المشكلة.',
	5076: 'إن عضو الفريق المحدد ليس عضواً نشطاً في مهمة التدقيق الحالية. يُرجى إعادة المحاولة أو اتصل بمكتب الدعم في حالة استمرار المشكلة.',
	5077: 'تم حذف مهمة واحدة أو أكثر من المهام المحددة. يُرجى إعادة المحاولة أو اتصل بمكتب الدعم في حالة استمرار المشكلة.',
	5078: 'تم حذف تعيين المهمة المحدد. يُرجى إعادة المحاولة أو اتصل بمكتب الدعم في حالة استمرار المشكلة.',
	5079: 'تم حذف مهمة واحدة أو أكثر من المهام المحددة. يُرجى إعادة المحاولة أو اتصل بمكتب الدعم في حالة استمرار المشكلة.',
	5080: 'Docuement Version record not exists.',
	5081: 'لا يمكن إعادة تعيين المستخدم الذي تم تعيينه حالياً لهذه المهمة كمُعد. يُرجى إعادة المحاولة أو اتصل بمكتب الدعم في حالة استمرار المشكلة.',
	5082: 'فشل التحديث. يجب أن يكون اسم المستند مميزاً لمهمة التدقيق. قم بتحديث الصفحة لإزالة هذه الرسالة.',
	5083: 'Task Detail characters limit is exceeded.',
	5084: 'Task Document create call failed.',
	5085: 'Task Document delete call failed.',
	5086: 'Task Handoffs create call failed.',
	5087: 'Task patch call failed.',
	5088: 'This task must contain evidence to hand-off. Try again or contact the Help Desk.',
	5089: 'All evidence associated to this task (with the exception of paper profiles) must have at least one preparer and reviewer to mark complete. Try again and contact the Help Desk if the error persists.',
	5091: 'Paper profile name already exists in the engagement.',
	5092: "Name cannot contain any of the following characters: */:<>\\?|\\",
	5093: "Paper profile name exceeds the maximum length (100 characters).",
	5111: 'The selected account, assertion, or limited risk account has been deleted. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*WCGW*/
	6001: 'فشل استدعاء إنشاء الخطأ المحتمل.',
	6002: 'اسم الخطأ المحتمل غير موجود.',
	6003: 'الخطأ المحتمل غير موجود.',
	6004: 'فشل استدعاء الخطأ المحتمل.',
	6005: 'معرف مهمة التدقيق غير صالح.',
	6006: 'معرف التأكيد غير صالح',
	6007: 'فشل استدعاء الخطأ المحتمل حسب المعرف.',
	6008: 'الطلب غير صالح.',
	6009: 'معرف الخطأ المحتمل غير صالح.',
	6038: 'لا يمكن ربط المهمة بالخطأ المحتمل.',
	6039: 'الخطأ المحتمل المحدد تم حذفه.',
	6040: 'المهمة والخطأ المحتمل لا يرتبطا بنفس التأكيد.',
	6041: 'المهمة المحددة لا تنتمي لنفس مهمة التدقيق.',
	6042: 'لا يمكن فصل المهمة عن الخطأ المحتمل.',

	/*Engagement*/
	7001: 'Get by ID not found.',
	7002: 'Get engagements by workspace ID call failed.',
	7003: 'GetAll engagement entities call failed.',
	7004: 'Get engagement by ID call failed.',
	7005: 'GetAll engagement users call failed.',
	7011: 'Create Engagement User call failed.',
	7012: '{0} {1} cannot be invited because he/she is already an active or pending team member.',
	7056: 'MS EY Canvas Landing Page is not accessible at this time and is required to edit.  Try again and if the issue persists, contact the Help Desk.',
	7058: 'MS Members cannot be deactivated. Engagement must have at least one member who has permissions to administer engagement. Update your selection and try again. If the issue persists, contact the Help Desk.',

	/*SCOT*/
	8001: 'فشل استدعاء إنشاء فئة المعاملات الجوهرية.',
	8002: 'اسم فئة المعاملات الجوهرية غير موجود.',
	8003: 'فئة المعاملات الجوهرية غير موجودة.',
	8004: 'فشل استدعاء فئة المعاملات الجوهرية.',
	8005: 'معرف مهمة التدقيق غير صالح.',
	8006: 'معرف التأكيد غير صالح',
	8007: 'فشل استدعاء فئة المعاملات الجوهرية حسب المعرف.',
	8008: 'الطلب غير صالح.',
	8009: 'AR MS SCOT is not valid.',

	/*User*/
	10001: 'Logged in User preferences not found.',
	10002: 'User GetAll call failed.',
	10003: 'User Presence Get call failed.',

	/*Risk Type*/
	11001: 'طلب الإنشاء غير صالح.',
	11002: 'اسم نوع المخاطر غير موجود.',
	11003: 'نوع المخاطر غير موجود.',
	11004: 'فشل استدعاء نوع المخاطر.',
	11005: 'معرف مهمة التدقيق غير صالح.',

	/*Documents*/
	14001: 'تعذر إجراء المكالمة لأن الطلب فارغ.',
	14002: 'لم يتم العثور على المستند. فشل الاستدعاء.',
	14003: 'يجب أن يكون معرف مهمة التدقيق أكبر من الصفر.',
	14004: 'يجب ألا يكون معرف المستند لا شيء أو فارغاً.',
	14005: 'حدث خطأ أثناء محاولة الحصول على المهام المرتبطة. فشل الاستدعاء.',
	14006: 'لا يمكن حذف المستند المحدد. أعد المحاولة لاحقاً. في حالة استمرار المشكلة، اتصل بمكتب الدعم.',
	14007: 'حدث خطأ غير متوقع.',
	14008: 'حدث خطأ غير متوقع عند التوقيع.',
	14009: 'حدث خطأ عند إضافة توقيع.',
	14010: 'يجب أن يكون معرف الاعتماد أكبر من الصفر.',
	14011: 'حدث خطأ عند حذف توقيع.',
	14012: 'لا يمكن أن يكون النص فارغاً.',
	14013: 'لا يمكن إلغاء ارتباط المستند المحدد. أعد المحاولة لاحقاً. في حالة استمرار المشكلة، اتصل بمكتب الدعم.',
	14016: 'Get Document Approval call failed.',
	14017: 'GetAll Document Findings call failed.',
	14018: 'GetAll Documents call failed.',
	14019: 'Approval not found.',
	14020: 'Invalid action value.',
	14021: 'Invalid finding type.',
	14022: 'The document does not belong to the engagement.',
	14023: 'The document change type is not valid.',
	14024: 'GetAll Documents call failed. Parameter is not valid.',
	14034: 'An Unlink process is in-progress for another engagement in the workspace or this document has already been unlinked. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	14035: 'The document is not shared with the given engagement.',

	/*SEM*/
	15001: 'فشل استدعاء ملخص تسويق محركات البحث لمعرف الحساب بسبب طلب غير صالح.',
	15002: 'معرف الحساب غير صالح.',
	15003: 'معرف مهمة التدقيق غير صالح.',
	15004: 'نوع الملخص غير صالح.',
	15005: ' Related account cannot be found. Refresh the page and try again. Contact the Help Desk if the issue persists.',

	/*Timephase*/
	16001: 'Get time phases failed.',
	16002: 'The engagement must be greater than zero.',
	16003: 'The time phase must be greater than zero.',
	16004: 'Invalid task id value.',
	16005: 'Invalid time phase value.',

	/*Validations*/
	17001: 'معرف خطوة البناء أو معرف نوع المستند غير موجود',

	/* Annotation Errors*/
	12001: ' Invalid request parameters.',
	12002: ' Create Annotation call failed.',
	12003: ' Get Annotation failed.',
	12004: ' Invalid Engagement ID.',
	12005: ' IDs in collection must be greater than zero.',
	12006: ' ID collection cannot be empty.',
	12007: 'Invalid Task ID.',
	12008: ' Invalid Document ID.',
	12009: ' Must have valid DocumentId or Task ID.',
	12010: ' Replies require parent.',
	12011: ' Invalid Status ID.',
	12012: ' Document type should be 440GL.',
	12013: ' Invalid annontation type.',
	12014: ' Invalid Engagement User.',
	12015: ' This document has been deleted by another user.',
	12016: ' Update Annotation call failed.',
	12017: 'You are trying to reply to a note that no longer exists. Refresh the page and try again.',
	12018: ' Annotation change action type should not be Null.',
	12019: 'Review note deleted.',
	12020: 'Invalid action to perform.',
	12021: 'User is not author of annotation.',
	12022: 'Missing authoring user.',
	12023: "Authoring user doesn't exist or belong to the engagement.",
	12024: 'Assigned user required.',
	12025: 'Assigned user does not exist or belong to the engagement.',
	12026: 'Invalid comments.',
	12027: 'Comments must not be empty.',
	12028: 'Due date required.',
	12029: 'Valid priority required.',
	12030: 'The status of this note has changed. You can no longer edit or respond to the note. Please close and re-open the window to see updated data and continue editing.',
	12031: 'Annotation must be top level.',
	12032: 'Annotation must not be top level.',
	12033: 'At least one of the following values must not be empty: priority type, due date, status or assigned user.',
	12034: 'Comment exceeds maximum length (4,000 characters).',
	12035: 'Search string exceeds maximum length (500 characters).',
	12036: 'Only TaskId Or DocumentId should be accepted both are not allowed.',
	12037: 'Invalid Patch Operation.',
	12038: 'You are trying to edit a note that no longer exists. Refresh the page and try again.',
	12039: 'You are trying to edit the same note as another team member. Refresh the page and try again.',
	12040: 'Get Annotation users call failed.',
	12041: 'Get annotation users failed. Invalid query value.',
	12042: 'Document type is not valid to create an annotation.',
	12043: 'You are trying to add a note to a task or document that no longer exists. Refresh the page and try again.',
	12044: 'You are trying to edit a reply to a note that no longer exists. Refresh the page and try again.',
	12045: 'Review Note not found.',
	12046: 'You are trying to delete a note that has already been deleted by another team member. Refresh the page and try again.',
	12047: 'You can only delete replies to notes that are in Open status. Refresh the page and try again.',
	12048: 'You are trying to change the status of a note that no longer exists. Refresh the page and try again.',

	/*TaskGroupSection*/
	18001: 'GetAll task group section call failed.',

	/*Assignments*/
	19001: 'Create assignment call failed.',
	19002: 'Get assignment call failed.',

	/*Client Request*/
	21001: 'Client request association call has failed.',

	/*Related Components*/
	22001: 'Get related components call failed.',

	/*User Presence*/
	23001: 'Logged in user presence not found.',
	23002: 'User presence get call failed.',
	23003: 'User presence document validation failed.',
	23004: 'User presence delete call failed.',

	/* Forms */
	24001: ' Get form call failed.',
	24002: ' Invalid Engagement ID.',
	24003: ' Document Id should not be null or empty.',
	24004: ' Invalid Document ID.',
	24005: ' Invalid Form Header ID.',
	24006: ' Invalid Form Section ID.',
	24007: ' Invalid request parameters.',
	24008: ' Header Id should not be null or empty.',
	24009: ' Section Id should not be null or empty.',
	24010: ' Form body response update operation failed.',
	24011: ' Invalid request for Form body response update.',
	24012: ' Invalid Body ID.',
	24013: ' Invalid Form Body Option ID.',
	24014: ' Invalid Form Body Type ID.',
	24015: ' Invalid Request body for given body Type ID.',
	24016: ' Invalid Free Text for given body Type ID.',
	24017: 'Maximum characters, includes rich text formatting tags. Either reduce the length or remove unnecessary formatting and try again.',
	24018: 'For given Body Type ID response is not allowed.',
	24019: 'Body ID should not be null or empty.',
	24020: 'Invalid Request Body.',
	24021: 'Body is deleted.',

	38046: 'Update comment call failed. Refresh the page and try again.',
	/*Doc Helper Custom Messages */
	0: ' Connection lost. Reconnect and try again. If the issue persists, contact the Help desk.',
	303: ' A document with the same name is currently being uploaded.',
	403: ' Invalid file type.',
	412: ' A document with the same name already exists in this engagement.',
	500: ' Connection lost. Reconnect and try again. If the issue persists, contact the Help Desk.',
	414: ' Name exceeds the maximum length ({0} characters).',
	600: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk.',
	601: 'Document with the same name exists.',
	602: 'Document is already in collaboration',
	603: 'Document not found.',
	'zip': ' The .zip file cannot be uploaded because it contains one or more unsupported file types, or it contains more than the maximum amount of embedded .zip files.',

	/* TimePhaseTypes - Milestones */
	27001: ' Get milestone details failed.',

	/* Content updates Error messages*/
	29004: 'Content Update api call failed.',
	29005: 'Content update in-progress. Try again later and if the issue persists, contact the Help Desk.',

	/* External user Error message*/
	7016: 'cannot be invited as the user is already an active team member in the following access group(s): ',
	7014: 'The EY Canvas Landing Page is not accessible at this time. Try again and if the issue persists, contact the Help Desk.',
	7015: 'Domain is not allowed for selected group(s).',
	7017: 'Domain is not allowed for selected group(s).',
	7027: 'Unable to complete operation. Try again and if the issue persists, contact the Help Desk.',
	7033: 'Create external user call failed.'
};
/*Label Collections */
export const riskTypes = [{
	id: 1,
	name: 'المخاطر الجوهرية',
	abbrev: 'مخاطر جوهرية'
},
{
	id: 2,
	name: 'مخاطر الاحتيال',
	abbrev: 'مخاطر الاحتيال'
},
{
	id: 3,
	name: 'المخاطر المصاحبة',
	abbrev: 'المخاطر الكامنة'
}
];
export const emptyRiskTypes = [
	{
		id: 1,
		label: 'No significant risks have been identified'
	},
	{
		id: 2,
		label: 'No fraud risks have been identified'
	},
	{
		id: 3,
		label: 'No inherent risks have been identified'
	}
];
export const controlRiskType = [{
	id: 1,
	name: 'اعتماد'
},
{
	id: 2,
	name: 'عدم اعتماد'
},
{
	id: 3,
	name: 'اختبار إجراءات الإدارة'
}
];
export const inherentRiskType = [{
	id: 1,
	name: 'أعلى'
},
{
	id: 2,
	name: 'أقل'
}
];
export const CRAStrings = {
	Minimal: 'أدنى',
	Low: 'منخفض',
	'Low +SC': 'منخفض + فئة جوهرية',
	Moderate: 'متوسط',
	High: 'مرتفع',
	'High +SC': 'مرتفع + فئة جوهرية'
};
export const priorityType = [{
	id: 1,
	name: 'منخفض',
	className: 'Low',
	label: 'L'
},
{
	id: 2,
	name: 'متوسط',
	className: 'Medium',
	label: 'M'
},
{
	id: 3,
	name: 'مرتفع',
	className: 'High',
	label: 'H'
},
{
	id: 4,
	name: 'هام',
	className: 'Critical',
	label: 'C'
}
];
export const reviewNoteFilterTypes = [{
	value: 0,
	label: 'الكل'
},
{
	value: 1,
	label: 'مفتوح'
},
{
	value: 5,
	label: 'ممسوح'
},
{
	value: 2,
	label: 'مغلق'
}
];
export const reviewStatus = [{
	id: 1,
	name: 'مفتوح'
},
{
	id: 2,
	name: 'مغلق'
},
{
	id: 3,
	name: 'معيّن'
},
{
	id: 4,
	name: 'معاد تعيينه'
},
{
	id: 5,
	name: 'ممسوح'
},
{
	id: 6,
	name: 'مرفوض'
},
{
	id: 7,
	name: 'معاد فتحه'
},
{
	id: 8,
	name: 'تم الحل'
}
];
export const reviewNoteOpenStatusOption = [{
	value: 1,
	label: 'مفتوح'
},
{
	value: 5,
	label: 'مسح'
},
{
	value: 2,
	label: 'إغلاق'
}
];
export const reviewNoteClearedStatusOption = [{
	value: 5,
	label: 'مسح'
},
{
	value: 1,
	label: 'إعادة فتح'
},
{
	value: 2,
	label: 'إغلاق'
}
];
export const reviewNoteBulkClearedStatusOption = [{
	value: 1,
	label: 'إعادة فتح'
},
{
	value: 5,
	label: 'مسح'
},
{
	value: 2,
	label: 'إغلاق'
}
];
export const reviewNoteClosedStatusOption = [{
	value: 2,
	label: 'إغلاق'
},
{
	value: 1,
	label: 'إعادة فتح'
}
];
export const signOffTypes = [{
	value: 0,
	label: 'مُعدّ'
},
{
	value: 1,
	label: 'مُراجع'
},
{
	value: 2,
	label: 'لا شيء'
}
];
export const RNHNoteStatusOptions = [{
	value: 1,
	label: 'Open'
},
{
	value: 2,
	label: 'Closed'
},
{
	value: 3,
	label: 'Cleared'
}
];
export const assertions = [{
	id: 1,
	assertionname: 'الاكتمال',
	assertionabbreviation: 'الاكتمال',
	statementtypeid: 2,
	displayorder: 1
},
{
	id: 2,
	assertionname: 'الوجود',
	assertionabbreviation: 'الوجود',
	statementtypeid: 2,
	displayorder: 2
},
{
	id: 3,
	assertionname: 'التقييم',
	assertionabbreviation: 'التقييم',
	statementtypeid: 2,
	displayorder: 3
},
{
	id: 4,
	assertionname: 'الحقوق والالتزامات',
	assertionabbreviation: 'الحقوق والالتزامات',
	statementtypeid: 2,
	displayorder: 4
},
{
	id: 5,
	assertionname: 'العرض والإفصاح',
	assertionabbreviation: 'العرض والإفصاح',
	statementtypeid: 2,
	displayorder: 5
},
{
	id: 6,
	assertionname: 'الاكتمال',
	assertionabbreviation: 'الاكتمال',
	statementtypeid: 1,
	displayorder: 6
},
{
	id: 7,
	assertionname: 'الحدوث',
	assertionabbreviation: 'الحدوث',
	statementtypeid: 1,
	displayorder: 7
},
{
	id: 8,
	assertionname: 'القياس',
	assertionabbreviation: 'القياس',
	statementtypeid: 1,
	displayorder: 8
},
{
	id: 9,
	assertionname: 'العرض والإفصاح',
	assertionabbreviation: 'العرض والإفصاح',
	statementtypeid: 1,
	displayorder: 9
},
{
	id: 10,
	assertionname: 'الاكتمال',
	assertionabbreviation: 'الاكتمال',
	statementtypeid: 3,
	displayorder: 10
},
{
	id: 11,
	assertionname: 'الوجود/الحدوث',
	assertionabbreviation: 'الوجود/الحدوث',
	statementtypeid: 3,
	displayorder: 11
},
{
	id: 12,
	assertionname: 'القياس/التقييم',
	assertionabbreviation: 'القياس/التقييم',
	statementtypeid: 3,
	displayorder: 12
},
{
	id: 13,
	assertionname: 'الحقوق والالتزامات',
	assertionabbreviation: 'الحقوق والالتزامات',
	statementtypeid: 3,
	displayorder: 13
},
{
	id: 14,
	assertionname: 'العرض والإفصاح',
	assertionabbreviation: 'العرض والإفصاح',
	statementtypeid: 3,
	displayorder: 14
}
];
//Add Review Note
export const priorityTypes = [{
	value: 1,
	label: 'منخفض'
},
{
	value: 2,
	label: 'متوسط'
},
{
	value: 3,
	label: 'مرتفع'
},
{
	value: 4,
	label: 'هام'
}
];
/*Cog Menu*/
export const cogMenuOptions = {
	Open: 'فتح',
	'Start Co-edit mode' : 'Start multi-user editing',
    'End Co-edit mode': 'End multi-user editing',
	'Open read-only': 'فتح للقراءة فقط',
	'View history': 'عرض السجل',
	Rename: 'إعادة تسمية',
	Delete: 'حذف',
	'Remove from task': 'إزالة من المهمة',
	Unlink: 'إلغاء الارتباط',
	RelateTasks: 'Relate tasks',
	Restore: 'Restore',
	PermanentlyDelete: 'Permanently delete',
	ChangeReason: 'Change reason'
};
export const pagingSvgHoverText = {
	first: 'الصفحة الأولى',
	previous: 'الصفحة السابقة',
	next: 'الصفحة التالية',
	last: 'الصفحة الأخيرة'
};
export const controlFrequencyType = {
	1: 'عدة مرات يومياً',
	2: 'يومياً',
	3: 'أسبوعياً',
	4: 'شهرياً',
	5: 'ربع سنوي',
	6: 'سنوياً',
	7: 'إجراء رقابة تطبيق تقنية المعلومات',
	8: 'أخرى'
};
export const itApproachType = {
	1: 'إجراءات الرقابة',
	2: 'جوهري'
};
export const controlType = {
	1: 'تطبيق تقنية المعلومات',
	2: 'دليل يعتمد على تقنية المعلومات',
	3: 'منع يدوي',
	4: 'اكتشاف يدوي'
};
export const aggregateITEvaluationType = {
	1: 'دعم',
	2: 'بدون دعم',
	3: 'دعم البيانات المالية والرقابة الداخلية على التقارير المالية',
	4: 'دعم البيانات المالية فقط'
};
export const iTProcessEvaluationType = {
	1: 'فعال',
	2: 'غير فعال',
	3: 'موثوق'
};
export const strategyType = {
	1: 'إجراءات الرقابة',
	2: 'جوهري',
	3: 'اعتماد',
	4: 'عدم اعتماد'
};
export const taskNavigation = {
	1: 'مهامي',
	2: 'جميع المهام',
	3: 'النطاق والاستراتيجية',
	4: 'SCOTs',
	5: 'IT/SOs',
	6: 'Accounts',
	7: 'General execution',
	8: 'الاستنتاج',
	9: 'ملخص الفريق'
};
export const subCategoryType = {
	AllTasks: {
		id: 1,
		title: 'إظهار الكل',
		label: 'إظهار الكل'
	},
	ToPrepare: {
		id: 2,
		title: 'لإعداد',
		label: 'لإعداد'
	},
	ToReview: {
		id: 3,
		title: 'لمراجعتي',
		label: 'لمراجعتي'
	}
};
/*Task Types*/
export const taskType = {
	1: 'المهمة القياسية',
	2: 'المهمة القياسية الرئيسية',
	3: 'مهمة المعاينة',
	4: 'مهمة الرقابة',
	5: 'المهمة الجوهرية',
	6: 'مهمة الإجراء الجوهري الرئيسي',
	7: 'مهمة الاستجابة',
	8: 'مهمة المجموعة'
};

export const taskTypesForAddTask = {
	importfromknowledge: 'Import from Knowledge',
	custom: 'Custom',
	account: 'Account',
	itsubstantive: 'IT substantive',
	walkthroughtask: 'Walkthrough task',
	controltask: 'Control task',
	itwalkthroughtask: 'IT walkthrough task',
	itcontroltask: 'IT control task'
};

export const taskTypeBadge = {
	1: 'OST',
	2: 'PST',
	3: 'WT',
	4: 'TOC',
	5: 'OSP',
	6: 'PSP',
	7: 'RT',
	8: 'GT',
	9: 'EP',
	10: 'EQR',
	11: 'EP/EQR',
	22: 'ACT'
};
/*Task Types*/
export const taskTypeAbbreviation = {
	1: 'TOC',
	2: 'TOC',
	3: 'TOC',
	4: 'TOC',
	5: 'TOC',
	6: 'TOC',
	7: 'RT',
	8: 'RT',
	9: 'RT',
	10: 'RT',
	11: 'RT',
	13: 'OST',
	14: 'PST',
	16: 'OSP',
	17: 'PSP',
	18: 'WT',
	19: 'WT',
	20: 'WT',
	22: 'ACT',
	23: 'GT',
	24: 'GT',
	25: 'GT',
	26: 'OSP',
	27: 'GT'
};
export const auditPhase = {
	1: 'النطاق والاستراتيجية',
	2: 'التنفيذ',
	3: 'الاستنتاج'
};
export const taskGroup = {
	1: 'Perform other planning procedures',
	2: 'Accounts Flow',
	3: 'Significant Class of Transactions (SCOTs) Flow',
	4: 'IT Applications & Service Organizations Flow',
	5: 'Combined Risk Assessment (CRA) Flow',
	6: 'Audit Plan Flow',
	7: 'Perform wrap up procedures',
	8: 'Summary of Audit Differences (SAD)',
	9: 'Evaluate Audit Results',
	10: 'Perform other audit procedures',
	11: 'Group Audit Structure',
	12: 'Group Audit Instructions',
	13: 'Primary Group Tasks',
	14: 'Component Group Tasks',
	15: 'Work Plan',
	16: 'Accounts Flow - MEST',
	17: 'Perform review procedures',
	18: 'Complete preliminary engagement activities',
	19: 'Establish the team',
	20: 'Enable the engagement with data',
	21: 'Analyze the data to inform our risk assessments',
	22: 'Identify significant accounts - MEST',
	23: 'Additional procedures to inform our risk assessments',
	24: 'Identify sources',
	25: 'Identify significant accounts',
	26: 'Identify and understand SCOTs',
	27: 'Identify and understand IT processes and service organizations',
	28: 'Confirm strategy and CRA',
	29: 'Perform additional required risk identification procedures',
	30: 'Consider the use of internal audit',
	31: 'Respond to risk assessments',
	32: 'Finalize strategy',
	33: 'EQR procedures',
	34: 'Design procedures',
	35: 'Evaluate and conclude on audit evidence',
	36: 'Issue communications and deliverables',
	37: 'EQR procedures',
	38: 'Prepare and issue the audit report',
	39: 'Finalize documentation and archive',
	40: 'Test entity-level controls',
	41: 'Assess data used in automated techniques',
	42: 'Execute required fraud procedures',
	43: 'Execute internal audit and specialist procedures',
	44: 'Evaluate IT processes',
	45: 'Minutes, contracts and litigation review',
	46: 'Perform procedures on financial statements',
	47: 'Execute RPTs, going concern and laws and regulations procedures',
	48: 'Discuss audit strategy revisions',
	49: 'Execution Conclusion',
	50: 'EQR procedures',
	51: 'Complete scope and strategy project management activities',
	52: 'Perform initial audit procedures',
	53: 'Perform risk assessment procedures',
	54: 'Identify service organizations',
	55: 'Digital - Task Group 5',
	56: 'Digital - Task Group 6',
	57: 'Digital - Task Group 7',
	58: 'Digital - Task Group 8',
	59: 'Digital - Task Group 9',
	60: 'Digital - Task Group 10',
	61: 'Digital - Task Group 11',
	62: 'Digital - Task Group 12',
	63: 'Digital - Task Group 13',
	64: 'Digital - Task Group 14',
	65: 'Digital - Task Group 15',
	66: 'Digital - Task Group 16',
	67: 'Digital - Task Group 17',
	68: 'Complete post-interim project management activities',
	69: 'Digital - Task Group 19',
	70: 'Digital - Task Group 20',
	71: 'Digital - Task Group 21',
	72: 'Digital - Task Group 22',
	73: 'Digital - Task Group 23',
	74: 'Digital - Task Group 24',
	75: 'Digital - Task Group 25',
	76: 'Digital - Task Group 26',
	77: 'Digital - Task Group 27',
	78: 'Digital - Task Group 28',
	79: 'Digital - Task Group 29',
	80: 'Digital - Task Group 30',
	81: 'Digital - Task Group 31',
	82: 'Digital - Task Group 32',
	83: 'Digital - Task Group 33',
	84: 'Digital - Task Group 34',
	85: 'Evaluate and conclude on review evidence',
	86: 'Digital - Task Group 36',
	87: 'Digital - Task Group 37',
	88: 'Digital - Task Group 38',
	89: 'Digital - Task Group 39',
	90: 'Digital - Task Group 40',
	91: 'Digital - Task Group 41',
	92: 'Digital - Task Group 42',
	93: 'Digital - Task Group 43',
	94: 'Digital - Task Group 44',
	95: 'Digital - Task Group 45',
	96: 'Digital - Task Group 46',
	97: 'Digital - Task Group 47',
	98: 'Digital - Task Group 48',
	99: 'Digital - Task Group 49',
	100: 'Digital - Task Group 50'
};
export const AutomationHubRequestStatus = {
	Draft: 'مسودة',
	Submitted: 'تم التقديم',
	Sent: 'الإرسال قيد التنفيذ',
	InProgress: 'جاري المعالجة',
	Failed: 'خطأ في المعالجة',
	Completed: 'مكتمل',
	FailedToSendToBP: 'خطأ في المعالجة',
	QueueingFailed: 'فشل التقديم',
	ActionRequired: 'يلزم اتخاذ إجراء'
};
export const milestonesLabels = {
	1: 'النطاق',
	2: 'الاستراتيجية',
	3: 'معاينات',
	4: 'اختبار اجراء الرقابة المرحلي',
	5: 'اختبار جوهري مرحلي',
	6: 'المعاينات (عمليات نهاية السنة)',
	7: 'اختبار اجراء الرقابة لنهاية السنة',
	8: 'اختبار جوهري لنهاية السنة',
	9: 'الاستنتاج',
	10: 'غير منطبق',
	11: 'التنفيذ',
	12: 'نطاق واستراتيجية إدارة المشاريع',
	13: 'نطاق واستراتيجية أخرى',
	14: 'التقييم الموحد للمخاطر',
	15: 'تقييم المخاطر وحد الإفصاح',
	16: 'إنهاء النطاق والاستراتيجية',
	17: 'إدارة المشاريع المرحلية اللاحقة'
};export const TasksFilterType = {
	TaskStatus: 'حالة المهمة',
	TaskType: 'نوع المهمة',
	AssignedTo: 'معيّن إلى',
	OpenAssignments: 'التعيينات المفتوحة',
	ReviewNotesStatus: 'حالة ملاحظات المراجعة',
	ReviewNotesAssignedTo: 'ملاحظات المراجعة معينة إلى',
	ReviewNotesCreatedBy: 'ملاحظات المراجعة تم انشاؤها بواسطة',
	TimePhase: 'الإطار الزمني',
	Milestone: 'مرحلة الإنجاز الرئيسية',
	AuditPhase: 'مرحلة التدقيق',
	AuditPhaseAlt: 'Engagement phase',
	DocumentConflict: 'تعارض المستندات',
	Findings: 'النتائج',
	Entity: 'المنشأة',
	IsBookmarked: 'Downloaded for offline',
}
export const TaskFilterOptions = {
	1: [{
		id: '1',
		name: 'فتح'
	},
	{
		id: '2',
		name: 'قيد التنفيذ'
	},
	{
		id: '3',
		name: 'قيد المراجعة'
	},
	{
		id: '4',
		name: 'مكتمل'
	},
	{
		id: '5',
		name: 'لا يوجد دليل'
	}
	],

	2: [{
		id: '1',
		name: 'مهمة الرقابة'
	},
	{
		id: '7',
		name: 'مهمة الاستجابة'
	},
	{
		id: '13',
		name: 'المهمة القياسية الأخرى'
	},
	{
		id: '14',
		name: 'المهمة القياسية الرئيسية'
	},
	{
		id: '16',
		name: 'مهمة الإجراء الجوهري الآخر'
	},
	{
		id: '17',
		name: 'مهمة الإجراء الجوهري الرئيسي'
	},
	{
		id: '18',
		name: 'مهمة معاينة'
	},
	{
		id: '22',
		name: 'مهمة استنتاج الحسابات'
	},
	{
		id: '999',
		name: 'توقيع شريك التدقيق مطلوب'
	},
	{
		id: '1000',
		name: 'توقيع مراجع جودة التدقيق مطلوب '
	}
	],

	'2|GroupEngagement': [{
		id: '1',
		name: 'مهمة الرقابة'
	},
	{
		id: '7',
		name: 'مهمة الاستجابة'
	},
	{
		id: '13',
		name: 'المهمة القياسية الأخرى'
	},
	{
		id: '14',
		name: 'المهمة القياسية الرئيسية'
	},
	{
		id: '16',
		name: 'مهمة الإجراء الجوهري الآخر'
	},
	{
		id: '17',
		name: 'مهمة الإجراء الجوهري الرئيسي'
	},
	{
		id: '18',
		name: 'مهمة معاينة'
	},
	{
		id: '22',
		name: 'مهمة استنتاج الحسابات'
	},
	{
		id: '23',
		name: 'مهمة المجموعة'
	},
	{
		id: '999',
		name: 'توقيع شريك التدقيق مطلوب'
	},
	{
		id: '1000',
		name: 'توقيع مراجع جودة التدقيق مطلوب '
	}
	],

	'2|InterimEngagement': [{
		id: '14',
		name: 'المهمة القياسية الرئيسية'
	},
	{
		id: '13',
		name: 'المهمة القياسية الأخرى'
	},
	{
		id: '23',
		name: 'مهمة المجموعة'
	},
	{
		id: '999',
		name: 'توقيع شريك التدقيق مطلوب'
	},
	{
		id: '1000',
		name: 'توقيع مراجع جودة التدقيق مطلوب '
	}
	],

	6: [{
		id: '1',
		name: 'فتح'
	},
	{
		id: '5',
		name: 'ممسوح'
	},
	{
		id: '2',
		name: 'مغلق'
	}
	],

	10: [{
		id: '12',
		name: 'نطاق واستراتيجية إدارة المشاريع'
	},
	{
		id: '13',
		name: 'نطاق واستراتيجية أخرى'
	},
	{
		id: '14',
		name: 'التقييم الموحد للمخاطر'
	},
	{
		id: '15',
		name: 'تقييم المخاطر وحد الإفصاح'
	},
	{
		id: '16',
		name: 'إنهاء النطاق والاستراتيجية'
	},
	{
		id: '17',
		name: 'إدارة المشاريع المرحلية اللاحقة'
	},
	{
		id: '3',
		name: 'معاينات'
	},
	{
		id: '4',
		name: 'اختبار اجراء الرقابة المرحلي'
	},
	{
		id: '5',
		name: 'اختبار جوهري مرحلي'
	},
	{
		id: '6',
		name: 'المعاينات (عمليات نهاية السنة)'
	},
	{
		id: '7',
		name: 'اختبار اجراء الرقابة لنهاية السنة'
	},
	{
		id: '8',
		name: 'اختبار جوهري لنهاية السنة'
	},
	{
		id: '11',
		name: 'AR - Execution'
	},
	{
		id: '9',
		name: 'الاستنتاج'
	},
	{
		id: '10',
		name: 'AR - N/A'
	},
	{
		id: '0',
		name: 'AR - No milestone'
	}
	],

	11: [{
		id: '1',
		name: 'النطاق والاستراتيجية'
	},
	{
		id: '2',
		name: 'التنفيذ'
	},
	{
		id: '3',
		name: 'الاستنتاج'
	}
	],

	12: [{
		id: '1',
		name: 'نعم'
	}, {
		id: '0',
		name: 'لا'
	}],

	13: [{
		id: '1',
		name: 'أوجه القصور'
	}, {
		id: '2',
		name: 'الأخطاء'
	}],
	15: [{
		id: '1',
		name: 'نعم'
	}, {
		id: '2',
		name: 'لا'
	}]
};

export const RoleForMember = [{
	id: 1,
	role: 'الشريك المسؤول',
	roleAbbreviation: 'الشريك المسؤول'
},
{
	id: 2,
	role: 'شريك التدقيق',
	roleAbbreviation: 'شريك التدقيق'
},
{
	id: 3,
	role: 'مدير تنفيذي',
	roleAbbreviation: 'EXEC DIR'
},
{
	id: 4,
	role: 'مدير',
	roleAbbreviation: 'PRINCIPAL'
},
{
	id: 5,
	role: 'مدير رئيسي',
	roleAbbreviation: 'SR.MANAGER'
},
{
	id: 6,
	role: 'مدير',
	roleAbbreviation: 'MANAGER'
},
{
	id: 7,
	role: 'مدقق رئيسي',
	roleAbbreviation: 'SENIOR'
},
{
	id: 8,
	role: 'الموظفين',
	roleAbbreviation: 'STAFF'
},
{
	id: 9,
	role: 'Intern',
	roleAbbreviation: 'Intrn'
},
{
	id: 10,
	role: 'مراجع جودة التدقيق',
	roleAbbreviation: 'مراجع جودة التدقيق'
},
{
	id: 11,
	role: 'شريك آخر',
	roleAbbreviation: 'OTHER PTR'
},
{
	id: 12,
	role: 'Global Talent Hub',
	roleAbbreviation: 'GTH'
},
{
	id: 13,
	role: 'Advisory (ITRA,TAS,Human Capital or Other)',
	roleAbbreviation: 'ADV'
},
{
	id: 14,
	role: 'Tax',
	roleAbbreviation: 'Tax'
},
{
	id: 15,
	role: 'Executive Support Services',
	roleAbbreviation: 'ESS'
},
{
	id: 16,
	role: 'General Counsel',
	roleAbbreviation: 'GCO'
},
{
	id: 17,
	role: 'Audit Quality Reviewer',
	roleAbbreviation: 'AQR'
},
{
	id: 18,
	role: 'ML Component Team',
	roleAbbreviation: 'MCT'
},
{
	id: 19,
	role: 'Client Supervisor',
	roleAbbreviation: 'ClntS'
},
{
	id: 20,
	role: 'Client Staff',
	roleAbbreviation: 'ClntSt'
},
{
	id: 21,
	role: 'Internal Audit Supervisor',
	roleAbbreviation: 'IASup'
},
{
	id: 22,
	role: 'Internal Audit Staff',
	roleAbbreviation: 'IASt'
},
{
	id: 23,
	role: 'Regulator',
	roleAbbreviation: 'Reglr'
},
{
	id: 24,
	role: 'Other (e.g. due diligence review)',
	roleAbbreviation: 'Otrs'
},
{
	id: 25,
	role: 'Office',
	roleAbbreviation: 'Off'
},
{
	id: 26,
	role: 'Area',
	roleAbbreviation: 'Area'
},
{
	id: 27,
	role: 'Industry',
	roleAbbreviation: 'IND'
},
{
	id: 28,
	role: 'National',
	roleAbbreviation: 'NAT'
},
{
	id: 29,
	role: 'Global',
	roleAbbreviation: 'GBL'
}
];
/* Task Status */
export const TaskStatus = [{
	id: 1,
	label: 'مفتوح'
},
{
	id: 2,
	label: 'قيد التنفيذ'
},
{
	id: 3,
	label: 'قيد المراجعة'
},
{
	id: 4,
	label: 'مكتمل'
},
{
	id: 5,
	label: 'تمت إزالته'
},
{
	id: 6,
	label: 'اكتمل تسجيل الخروج PIC/EQR'
}
];
export const TeamSummaryPreparerTaskStatus = [{
	id: 1,
	label: 'لم يتم البدء'
},
{
	id: 2,
	label: 'قيد التنفيذ'
},
{
	id: 3,
	label: 'تم'
}
];
export const TeamSummaryReviewerTaskStatus = [{
	id: 4,
	label: 'للمراجعة القادمة'
},
{
	id: 5,
	label: 'قيد التنفيذ'
},
{
	id: 6,
	label: 'تم'
}
];
export const DocumentHelper = {
	413: 'المستند يتجاوز الحد الأقصى المسموح به لحجم الملف (250 ميجا بايت) ولا يمكن تحميله. قم بتقليل حجم الملف وأعد المحاولة مرة أخرى.',
	412: 'يوجد بالفعل مستند بهذا الاسم في مهمة التدقيق الحالية'
};
export const reviewNoteCategories = [
	{ value: reviewNoteRoutes.path.all.id, path: reviewNoteRoutes.path.all.path, label: 'All notes' },
	{ value: reviewNoteRoutes.path.document.id, path: reviewNoteRoutes.path.document.path, label: 'Document notes' },
	{ value: reviewNoteRoutes.path.task.id, path: reviewNoteRoutes.path.task.path, label: 'Task notes' }
];
export const reviewNoteStatus = [{
	value: '1',
	label: 'Open'
},
{
	value: '5',
	label: 'Cleared'
},
{
	value: '2',
	label: 'Closed'
}
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
	id: 1,
	type: 'document',
	label: 'Document note'
},
{
	id: 2,
	type: 'task',
	label: 'Task note'
}
];

export const accountConclusionTabs = {
	details: 'Details',
	conclusions: 'Conclusions'
};

export const rnhFilterType = [{
	id: 0,
	filterType: 'annotationStatusIds',
	name: 'Note status Id',
	inDropDown: false
},
{
	id: 1,
	filterType: 'reviewnotesauthoredby',
	name: 'Authored by',
	inDropDown: true
},
{
	id: 2,
	filterType: 'reviewnotesassignedto',
	name: 'Assigned to',
	inDropDown: true
},
{
	id: 3,
	filterType: 'prioritytype',
	name: 'Priority',
	inDropDown: true,
	filterOptions: [{
		id: '1',
		label: 'Low'
	}, {
		id: '2',
		label: 'Medium'
	}, {
		id: '3',
		label: 'High'
	}, {
		id: '4',
		label: 'Critical'
	}]
},
{
	id: 4,
	filterType: 'duedateend',
	name: 'Due on or before',
	inDropDown: true,
	isDateTime: true
},
{
	id: 5,
	filterType: 'duedatestart',
	name: 'Due on or after',
	inDropDown: true,
	isDateTime: true
}
];

export const rnhSortingOptions = [{
	id: 0,
	label: 'Reference number'
}, {
	id: 2,
	label: 'Due date'
}, {
	id: 3,
	label: 'Priority'
}];

export const userConfidentiality = [{
	id: 1,
	value: 'General'
},
{
	id: 2,
	value: 'Low'
},
{
	id: 3,
	value: 'Medium'
},
{
	id: 4,
	value: 'High'
},
{
	id: 5,
	value: 'Restricted'
},
{
	id: 6,
	value: 'Confidential'
}
];

export const externalUserStatus = {
	active: 'Active,',
	inactive: 'Inactive'
};

export const engagementStatus = {
	1: 'Active,',
	2: 'Pending,',
	3: 'Rejected,',
	4: 'Inactive'
};

export const independenceStatus = {
	0: 'Undefined',
	1: 'Incomplete',
	2: 'No Matters Identified',
	3: 'Matter Identified - Pending Action',
	4: 'Matter Resolved - Denied Access',
	5: 'Matter Resolved - Granted Access',
	6: 'Not Applicable',
	7: 'Restored',
	8: 'Overridden'
};

export const timePhaseTypes = {
	1: 'Scope',
	2: 'Strategy',
	3: 'Walkthroughs',
	4: 'Interim Control Testing',
	5: 'Interim Substantive Testing',
	6: 'Walkthroughs (year-end processes)',
	7: 'Year-end Control Testing',
	8: 'Year-end Substantive Testing',
	9: 'Conclusion',
	10: 'N/A',
	11: 'Execution',
	12: 'Scope and strategy project management',
	13: 'Other scope and strategy',
	14: 'CRA',
	15: 'Risk Assessment and Materiality',
	16: 'Finalize scope and strategy',
	17: 'Post-interim project management'
};

export const engagementMetricsComingDueOptions = [{
	value: 2,
	label: 'Tomorrow'
},
{
	value: 3,
	label: 'Next 3 days'
},
{
	value: 5,
	label: 'Next 5 days',
	isDefault: true
},
{
	value: 10,
	label: 'Next 10 days'
},
{
	value: 30,
	label: 'Next 30 days',
	isMax: true
}
];

export const engagementMetricsWhatsNewOptions = [{
	value: 2,
	label: "Yesterday"
},
{
	value: 3,
	label: "Last 3 days"
},
{
	value: 5,
	label: "Last 5 days",
	isDefault: true
},
{
	value: 10,
	label: "Last 10 days",
	isMax: true
}
];

export const engagementMetricsDisplayedAttributes = {
	partnerTasks: 'Partner tasks',
	eqrTasks: 'EQR tasks',
	timephases: 'Time phases',
	groupTasks: 'Group tasks',
	groupDeliverables: 'Group deliverables ',
	automation: 'Automation',
	requests: 'Requests'
};

export const quickLinks = {
	linkAccountSummary: 'Accounts summary',
	linkScotSummary: 'SCOTs summary',
	linkITSummary: 'IT summary',
	linkCRASummary: 'CRA summary',
	linkGAStructureSummary: 'Group structure summary',
	linkGAInstrcutionSummary: 'Group instructions summary',
	linkSEM: 'Substantive evaluation matrix',
	linkAuditPlan: 'Audit plan',

	linkGeneral: 'General',
	linkScots: 'SCOTs',
	linkITSO: 'IT/SO',
	linkAccounts: 'Accounts',
	linkResponseTask: 'Response tasks',
	linkWrapupEngagement: 'Wrap up engagement',
	linkArchive: 'Archive'
};

export const customKeyEvents = {
	reportDate: 'Report date',
	endDatePeriodCovered: 'End date of period covered',
	archiveDeadlineDate: 'Archive deadline date'
};

export const documentChangeTypes = {
	0: 'No reason for change selected',
	1: 'Non-adminstrative change',
	2: 'Accepting revisions when the track changes functionality was used',
	3: 'Adding additional cross referencing to evidence that already exists',
	4: 'Adding an original confirmation response previously received via fax or email',
	5: 'Cosmetic change',
	6: 'Completing Form AP',
	7: 'Deleting or discarding superseded documentation',
	8: 'Preparing the management letter',
	9: 'Signing off on completion checklists relating to the archive process',
	10: 'Sorting, collating and cross-referencing final documents'
};

export const documentChangeTypesOptions = [{
	value: 1,
	label: 'Non-adminstrative change'
},
{
	value: 2,
	label: 'Accepting revisions when the track changes functionality was used'
},
{
	value: 3,
	label: 'Adding additional cross referencing to evidence that already exists'
},
{
	value: 4,
	label: 'Adding an original confirmation response previously received via fax or email'
},
{
	value: 5,
	label: 'Cosmetic change'
},
{
	value: 6,
	label: 'Completing Form AP'
},
{
	value: 7,
	label: 'Deleting or discarding superseded documentation'
},
{
	value: 8,
	label: 'Preparing the management letter'
},
{
	value: 9,
	label: 'Signing off on completion checklists relating to the archive process'
},
{
	value: 10,
	label: 'Sorting, collating and cross-referencing final documents'
}
];

export const FourFortyFilterTypes = [{
	id: 0,
	filterType: 'QuickFilter',
	name: 'Quick filters',
	hasChild: false
},
{
	id: 1,
	filterType: 'TaskStatus',
	name: 'Task status',
	hasChild: false
},
{
	id: 2,
	filterType: 'TaskType',
	name: 'Task type',
	hasChild: false
},
{
	id: 3,
	filterType: 'AssignedTo',
	name: 'Assigned to',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 4,
	filterType: 'OpenAssignment',
	name: 'Open assignments',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 5,
	filterType: 'AssignmentsUsersEngagementRoles',
	name: 'Open assignments',
	hideDisplay: true,
	loadOptionsFromServer: true
},
{
	id: 6,
	filterType: 'ReviewNotesStatus',
	name: 'Review notes status',
	hasChild: false
},
{
	id: 7,
	filterType: 'ReviewNotesAssignedTo',
	name: 'Review notes assigned to',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 8,
	filterType: 'ReviewNotesCreatedBy',
	name: 'Review notes created by',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 9,
	filterType: 'TimePhase',
	name: 'Time phase',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 10,
	filterType: 'Milestone',
	name: 'Milestone',
	hasChild: false
},
{
	id: 11,
	filterType: 'AuditPhase',
	name: 'Audit phase',
	altName: 'Engagement phase',
	hasChild: false
},
{
	id: 12,
	filterType: 'DocumentConflict',
	name: 'Document conflict',
	hasChild: false
},
{
	id: 13,
	filterType: 'Findings',
	name: 'Findings',
	hasChild: false,
	hideForNonAudit: true
},
{
	id: 14,
	filterType: 'Entity',
	name: 'Entity',
	hasChild: false,
	loadOptionsFromServer: true,
	hideForNonMest: true
},
{
	id: 15,
	filterType: 'IsBookmarked',
	name: 'Downloaded for offline',
	hasChild: false
}
];

/* Arc Timeline */
export const arcValidationGroups = [
	{ id: 1, label: 'Build Step 29 ???' },
	{ id: 2, label: 'Build Step 30 ???' },
	{ id: 3, label: 'SEM (Evaluation Matrix) ???' },
	{ id: ArcTimelineGroups.FinalizeEvidence, label: 'Finalize evidence' },
	{ id: ArcTimelineGroups.CompleteRemainingTasks, label: 'Complete remaining tasks' },
	{ id: ArcTimelineGroups.ResolveValidations, label: 'Resolve remaining validations' },
	{ id: 7, label: 'Prepare for archive' },
	{ id: 8, label: 'Engagement Dashboard' },
	{ id: 9, label: 'Canvas Form (Individual)' },
	{ id: 10, label: 'Canvas Form (All)' }
];

export const checkListTypes = [{
	id: 7,
	label: 'Finalize hard copy files and folders'
},
{
	id: 13,
	label: 'Confirm the accuracy of key engagement dates'
},
{
	id: 14,
	label: 'Confirm the accuracy of key engagement codes'
},
{
	id: 15,
	label: 'Confirm the accuracy of the client code'
},
{
	id: 10,
	label: 'Unlink this engagement from the group'
},
{
	id: 16,
	label: 'Validate the report type'
},
{
	id: 17,
	label: 'Review temporary files for those modified after the report release date'
},
{
	id: 18,
	label: 'Review deleted files for those modified after the report release date'
}
];

export const arcValidationTypes = [
	{ id: ArcTimeLineValidationTypes.DocumentConflict, label: 'Resolve remaining document conflicts' },
	{ id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes, label: 'Close all unresolved review notes' },
	{ id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence, label: 'Remove tracked changes from evidence' },
	{ id: ArcTimeLineValidationTypes.EvidencemissingSignoffs, label: 'Signoff on all evidence' },
	{ id: ArcTimeLineValidationTypes.CanvasFormComment, label: 'Resolve Canvas form comments' },
	{ id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence, label: 'Unlinked shared evidence' },
	{ id: ArcTimeLineValidationTypes.TaskswithoutEvidence, label: 'Add evidence to open tasks' },
	{ id: ArcTimeLineValidationTypes.MarkTasksComplete, label: 'Mark tasks complete' },
	{ id: ArcTimeLineValidationTypes.AccountsSummary, label: 'Accounts summary' },
	{ id: ArcTimeLineValidationTypes.ScotSummary, label: 'SCOTs summary' },
	{ id: ArcTimeLineValidationTypes.CraSummary, label: 'CRA summary' },
	{ id: ArcTimeLineValidationTypes.ITSummary, label: 'IT summary' },
	{ id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport, label: 'Confirm accuracy of auditors report data' },
	{ id: ArcTimeLineValidationTypes.CompleteArchiveForm, label: 'Complete archive form' },
	{ id: ArcTimeLineValidationTypes.CompleteArchiveTask, label: 'Complete archive task' },
	{ id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence, label: 'Unlink group shared evidence' },
	{ id: ArcTimeLineValidationTypes.AuditPlan, label: 'Audit plan' },
	{ id: ArcTimeLineValidationTypes.UnassociateFinding, label: 'Unassociated findings' },
	{ id: ArcTimeLineValidationTypes.IndependenceCompliance, label: 'Independence compliance' },
	{ id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses, label: 'Finalize incomplete Canvas form responses' },
	{ id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask, label: 'Substantive evaluation matrix' },
	{ id: ArcTimeLineValidationTypes.ITEvaluation, label: 'IT evaluations' },
	{ id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate, label: 'Documents modified after the report release date' },
	{ id: ArcTimeLineValidationTypes.DuplicateFileNames, label: 'Rename evidence and temporary files with duplicate file names' }
];

export const validationTypes = [
	{ id: 1, label: 'Independence compliance' },
	{ id: 19, label: 'IT summary' },
	{ id: 20, label: 'Confirm accuracy of auditors report data' },
	{ id: 21, label: 'Complete archive form' },
	{ id: 22, label: 'Complete archive task' },
	{ id: 23, label: 'Unlink group shared evidence' },
	{ id: 26, label: 'Audit plan' },
	{ id: 38, label: 'Resolve remaining document conflicts' },
	{ id: 40, label: 'Signoff on all evidence' },
	{ id: 41, label: 'Add evidence to open tasks' },
	{ id: 45, label: 'IT evaluations' },
	{ id: 49, label: 'Unassociate findings' },
	{ id: 51, label: 'Substantive evaluation matrix' },
	{ id: 52, label: 'CRA summary' },
	{ id: 53, label: 'Accounts summary' },
	{ id: 54, label: 'SCOTs summary' },
	{ id: 60, label: 'Resolve Canvas form comments' },
	{ id: 61, label: 'Finalize incomplete Canvas form responses' },
	{ id: 62, label: 'Close all unresolved review notes' },
	{ id: 63, label: 'Remove tracked changes from evidence' },
	{ id: 64, label: 'Mark tasks complete' },
	{ id: 65, label: 'Unlinked shared evidence' },
	{ id: 66, label: 'Documents without a modification type selected' },
	{ id: 67, label: 'Non-adminstrative changes without change reason (rationale)' },
	{ id: 68, label: 'Unapproved modifications for non-adminstrative changes by appropriate role' },
	{ id: 69, label: 'Unlinked shared evidence' },
	{ id: 80, label: '440 GL missing executive reviewer sign-off' },
	{ id: 100, label: 'Finalize hard copy files and folders' }
];

export const contentType = {
	1: 'Primary standard tasks (PSTs)',
	2: 'Primary substantive procedures Index (PSP index)',
	3: 'Primary substantive procedures (PSPs)',
	4: 'Group audit instructions',
	5: 'Canvas forms from Knowledge',
	6: 'Canvas forms created by users (example: SCOT form)',
	7: 'Independence'
};
export const reportTypes = {
	1: 'Unqualified - with Emphasis Of Matter',
	2: 'Unqualified - without Emphasis Of Matter',
	3: 'Qualified - with Emphasis Of Matter',
	4: 'Qualified - without Emphasis Of Matter',
	5: 'Adverse opinion - with Emphasis Of Matter',
	6: 'Adverse opinion - without Emphasis Of Matter',
	7: 'Disclaimer Of opinion - with Emphasis Of Matter',
	8: 'Disclaimer Of opinion - without Emphasis Of Matter',
	100: 'No',
	101: 'N/A',
	102: 'Is the report(s) qualified in any way and/or does it have emphasis of matter?: Not yet selected'
};
export const epTasksObj = [{
	value: '3',
	label: 'No documents signed-off'
},
{
	value: '2',
	label: 'Some documents signed-off'
},
{
	value: '1',
	label: 'All documents signed-off'
}
];
export const eqrTasksObj = [{
	value: '6',
	label: 'No documents signed-off'
},
{
	value: '5',
	label: 'Some documents signed-off'
},
{
	value: '4',
	label: 'All documents signed-off'
}
];

export const generalLabelsForMobile = {
	noRecordsFound: 'No results found within this task category',
	taskListTitle: 'My tasks',
	taskEvidenceTitle: 'Evidence',
	cameraPagesTitle: 'Pages',
	cameraTitle: 'Camera',
	taskDetailsTitle: 'Task details',
	invalidPage: 'No Page Found',
	combinedTaskLabel: 'PIC/EQR',
	picTaskLabel: 'PIC',
	eqrTaskLabel: 'EQR',
	pageLabel: 'Page',
	ofLabel: 'of',
	noTasksAvailable: 'No tasks available',
	searchLabel: 'Search...',
	noDescriptionAvailable: 'No description available.',
	knowledge: 'Knowledge',
	description: 'Description',
	knowledgeDescription: 'Knowledge description',
	customized: 'Customized',
	taskDetailsTitle: 'Task details',
	unassigned: 'Unassigned',
	assignTo: 'Assigned to ',
	signOffLabel: 'Sign-offs',
	evidenceNoteLabel: 'Evidence Notes',
	attributeLabel: 'Attributes',
	addNoteLabel: 'Add note',
	addCommentLabel: 'Add comment',
	editCommentLabel: 'Update comment',
	addReplyNoteLabel: 'Reply to this note',
	replyNoteLabel: 'Reply',
	replyEditNoteLabel: 'Edit Reply',
	enterReplyPlaceholder: 'Enter reply',
	editNoteLabel: 'Edit',
	deleteNoteLabel: 'Delete',
	reopenNoteLabel: 'Reopen',
	closeNoteLabel: 'Close',
	clearNoteLabel: 'Clear',
	preparerAbbrv: 'P',
	reviewerAbbrv: 'R',
	uploadPhoto : 'Upload photo',
	noEvidenceFound : 'No evidence is associated to the task',
	noRegionComponentFound: 'No documents received from regional or component team',
	noEvidenceMessage : 'Click Upload photo to upload evidences',
	noNotesFound : 'No notes found',
	noNotesStatement: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	regionComponentEvidence: 'Region and component evidence',
	documentWarning: 'Downloaded document will be read-only. Please dispose of the file when done.',
	preparerTitle: 'Preparer sign-offs',
	reviewerTitle: 'Reviewer sign-offs',
	teamLabel: 'Team',
	saveEvidenceTitle: 'Save evidence',
	saveButton: 'Save',
	cancelButton: 'Cancel',
	confirmButtonLabel: 'Confirm',
	previewButton:'Preview',
	evidenceLable: 'Name of the evidence',
	mergingTitleLable: 'images merged to PDF.',
	showErrFileExistMsg: 'File name already exists.Please rename the file.',
	showErrForNoImgExist:'No images available for PDF generation.',
	showErrBlankFileNameMsg: 'File name cannot be blank.',
	showIsCompletedMessage: 'File uploaded successfully.',
	uploadingTitle:'Processing',
	showErrImgContext:'useImages must be used within an ImagesProvider',
	PagePreviewTitle:'Page',
	regionComponentEvidenceLabel: 'Region and component evidence',
	downloadProcessLabel: 'Downloading...',
	downloadCompleteLabel: 'Download Complete',
	taskNotes: 'Task notes',
	documentNotes: 'Document notes',
	dueDateLabel: 'Due date',
	view: 'View:',
	documentNotes: 'Document notes',
	newNote: 'New note',
	editNote: 'Edit note',
	assignedTo: 'Assigned to',
	priority: 'Priority',
	select: 'Select',
	dueDate: 'Due date',
	addNewNote: 'Add a new note',
	addNote:'Add note',
	updateNote: 'Update note',
	enterDescription: 'Enter a description...',
	allnotes: 'All notes',
	mynotes: 'My notes',
    assignedToMe: 'Assigned to me',
	hashValue: '#',
	showLessToggle: 'Show less',
	showMoreToggle: 'Show more',
	delete: 'Delete',
	deleteNoteModalTitle: 'Delete Message',
	deleteReplyModalTitle: 'Delete Reply',
	confirmDeleteNoteLabel: 'Are you sure that you want to delete the selected note?',
	confirmDeleteReplyLabel: 'Are you sure that you want to delete your reply to this note?',
	downloadInfo: 'Downloading a file containing # character is not allowed',
	evidenceFileValidationInfo: 'File Name cannot include */ : <>\?| " characters',
	previewPageTitle: 'Preview',
	redirecting: 'Redirecting to landing page in few seconds...',
	redirectingToTask: 'Redirecting to \'My Tasks\' page in few seconds...',
	errorApplyingConstraints: 'Error applying constraints:',
	zoomIsNotSupported:'Zoom is not supported on this device.',
	errorCheckingCameraCapability:'Error checking camera capabilities:',
	previous:'previous',
	next:'next',
	after:'after',
	redirectingToTaskDetails: 'Redirecting to task details in few seconds',
	mobileURL: '/mobile',
};
